/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useMemo, useRef, useContext } from 'react';
import { NavbarSlotContext } from '../../context/NavbarSlotContext';
import FormControl from '@mui/material/FormControl';
import { Label } from 'reactstrap';
import {
  FormControlLabel,
  Paper,
  TextField,
  Box,
  createFilterOptions,
  Grid,
  Chip,
  CircularProgress,
  Button,
  Typography,
  Alert,
  Snackbar,
  GlobalStyles,
  Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Autocomplete from '@mui/material/Autocomplete';
import Switch from '@mui/material/Switch';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useStyles } from './styles';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { MetaTags } from 'react-meta-tags';
import {
  AddLocation,
  CalculateDistance,
  GetAagencyUserDetails,
  GetLocationsJSON
} from '../../apis/Agency';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setClassDimensionsButton } from '../../Redux/ClassDimensionsBtnSlice';
import {
  setQuickQuoteRateValues,
  setQuickQuoteTLRateValues
} from '../../Redux/QuickQuoteRateSlice';
import {
  setQuickQuoteDeliveryCheckedRedux,
  setQuickQuotePickUpCheckedRedux
} from '../../Redux/QuickQuoteSwevicesSlice';
import { setClassRows } from '../../Redux/QuickQuoteAddedRows';
import { setDimensionRows } from '../../Redux/QuickQuoteDimenionsAddedRows';
import {
  setClassWeight,
  setDimensionsWeight
} from '../../Redux/QuickQuoteTotalWeightSlice';
import { base_url } from '../../apis/constants';
import ReactQuill from 'react-quill';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddIcon from '@mui/icons-material/Add';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import { setQuickQuoteRateLoc } from '../../Redux/QuickQuoteRateSlice';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import 'react-datepicker/dist/react-datepicker.css';
import { DateRangeFilter } from '../CustomDatePicker/CustomDatePicker';
import { cleanHtmlString, formatNumberWithCommas } from '../../apis/Utils';
import { getCoordinatesByAddress } from '../../apis/Utils';
import { ToastContainer } from 'react-toastify';
import dayjs from 'dayjs';
import AddressAutocomplete from '../Carriers/AddressAutocomplete';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import TuneIcon from '@mui/icons-material/Tune';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

function QSectionHeader({
  icon: Icon,
  title,
  titleAddon,
  action,
  iconBg = '#EBF2FF',
  iconColor = '#005AFF'
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: '6px',
          bgcolor: iconBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}
      >
        <Icon sx={{ fontSize: 15, color: iconColor }} />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          minWidth: 0
        }}
      >
        <Typography
          sx={{ fontWeight: 700, fontSize: 13, color: 'text.primary' }}
        >
          {title}
        </Typography>
        {titleAddon}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}

function QFieldLabel({ label, required }) {
  return (
    <Typography
      variant='caption'
      sx={{
        fontWeight: 500,
        fontSize: 11,
        color: 'text.secondary',
        mb: 0.2,
        display: 'block'
      }}
    >
      {label}
      {required && <span style={{ color: '#EF4444', marginLeft: 2 }}>*</span>}
    </Typography>
  );
}

function HazmatToggle({ checked, onChange }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '1px solid',
        borderColor: checked ? 'error.main' : 'divider',
        borderRadius: '8px',
        px: 1.5,
        height: 32,
        bgcolor: checked ? 'error.50' : 'background.paper'
      }}
    >
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: checked ? 'error.main' : 'text.secondary'
        }}
      >
        {checked ? 'Yes' : 'No'}
      </Typography>
      <Switch
        size='small'
        checked={!!checked}
        onChange={onChange}
        sx={{
          '& .MuiSwitch-switchBase.Mui-checked': { color: 'error.main' },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: 'error.main'
          }
        }}
      />
    </Box>
  );
}

function QuickQuote(props) {
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const weightRefs = useRef([]);
  // For GrossWeight refs
  const grossWeightRefs = useRef([]);
  const shipFromReqId = useRef(0);
  const shipToReqId = useRef(0);
  const [result, setResult] = useState([]);
  const [DBJson, setDBJson] = useState([]);
  const [ratesDisable, setRatesDisable] = useState(false);
  const [, setAddType] = useState('');
  const [, setZip] = useState('');
  const [, setState] = useState('');
  const [, setCountry] = useState('');
  const [totalNmbofUnits, setTotalNmbofUnits] = useState('');

  const [originOpenTimeValue, setOriginOpenTimeValue] = useState(
    dayjs('2024-02-17T08:00').format('HH:mm')
  );
  const [originCloseTimeValue, setOriginCloseTimeValue] = useState(
    dayjs('2024-02-17T16:00').format('HH:mm')
  );
  const [deliveryOpenTimeValue, setDeliveryOpenTimeValue] = useState(
    dayjs('2024-02-17T08:00').format('HH:mm')
  );
  const [deliveryCloseTimeValue, setDeliveryCloseTimeValue] = useState(
    dayjs('2024-02-17T16:00').format('HH:mm')
  );

  const handleSearch = async (query, apiRes, type) => {
    setGoogleQuery(query);
    const coordinates = await getCoordinatesByAddress(query);
    // const isMatch = coordinates.includes(apiRes[0]);
    setDBJson(apiRes);
    setAddType(type);

    if (coordinates) {
      setResult(coordinates);
      const uniqueResults = [...new Set(coordinates)];
      const updatedApiRes = [...new Set([...apiRes, ...uniqueResults])];
      setShipCity(updatedApiRes);
    } else {
      setResult([]);
    }
  };

  const today = new Date().toISOString().split('T')[0];
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [shipCity, setShipCity] = useState([]);

  function parseTLFlowAddress(addressString) {
    if (!addressString) return {};

    const parts = addressString.trim().split(/\s+/);

    const countryCode = parts.pop(); // last = country
    const postalCodeParts = [];

    // Handle Canadian postal code with space (2 parts)
    if (
      parts.length >= 2 &&
      /^[A-Za-z]\d[A-Za-z]$/.test(parts[parts.length - 2]) &&
      /^\d[A-Za-z]\d$/.test(parts[parts.length - 1])
    ) {
      postalCodeParts.unshift(parts.pop());
      postalCodeParts.unshift(parts.pop());
    } else {
      postalCodeParts.unshift(parts.pop()); // normal ZIP or single block postal code
    }

    const postalCode = postalCodeParts.join(' ');
    const stateOrProvinceCode = parts.pop(); // now last = state
    const city = parts.join(' '); // rest = city

    return {
      city,
      stateOrProvinceCode,
      postalCode,
      countryCode
    };
  }

  const parseAddress = address => {
    if (typeof address !== 'string' || !address.trim()) {
      return { city: '', state: '', zip: '', countryCode: '' };
    }

    const addressParts = address.trim().split(/\s+/); // split by spaces safely

    if (addressParts.length < 4) {
      return { city: '', state: '', zip: '', countryCode: '' };
    }

    const countryCode = addressParts.pop();
    const zipCode = addressParts.pop();
    const state = addressParts.pop();
    const city = addressParts.join(' ');

    return { city, state, zip: zipCode, countryCode };
  };

  function isQueryZip(str) {
    // return str.length > 4;
    return (
      /^\d{5}(-\d{4})?$/.test(str) || // US ZIP (5-digit or ZIP+4)
      /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/.test(str) || // Canada (A1A1A1 format)
      /^\d{5}$/.test(str) // Mexico (5-digit only)
    );
  }

  const handleUSAddresses = (apiRes, type, squery) => {
    if (apiRes) {
      isQueryZip(squery) && handleSearch(squery, apiRes, type);
      // setGoogleQuery(squery);
      // setGoogleModal(true);
      // }
      if (type === 'shipFrom') {
        setShipFromHoveredValue(apiRes[0]);
      } else {
        setShipToHoveredValue(apiRes[0]);
      }

      const uniqueResults = [...new Set(result)];
      const updatedApiRes = [...new Set([...apiRes, ...uniqueResults])];

      setShipCity(updatedApiRes);
      setShipFromloading(false);
      setShipToloading(false);
    }
    // if (
    //   // apiRes.length === 0 &&
    //   isQueryZip(squery)
    // ) {
  };

  var layoutMode = document.body.getAttribute('data-layout-mode');
  const selectShipType = useRef(null);
  const selectLocations = useRef(null);
  const selectShipFrom = useRef([]);
  const selectShipTo = useRef([]);
  const enterWeight = useRef([]);
  const grossWeightRefsDelivery = useRef([]);

  const viewShipmentsData = useSelector(state => state.getShipments);
  const SelectedRates = useSelector(state => state.quickQuoteRate);
  const quickQuoteTLRates = useSelector(state => state.quickQuoteTLRate);
  const SelectedLoc = useSelector(
    state => state.quickQuoteLoc.QuickQuoteRateLoc
  );
  const AddedClassRows = useSelector(state => state.newAddedPersistedRows);
  const AddedDimensionsRows = useSelector(
    state => state.newAddedPersistedDimensionsRows
  );
  const getPickupOption = option =>
    SelectedRates?.pickupOptions?.[option] ?? false;

  const getDeliveryOption = option =>
    SelectedRates?.deliveryOptions?.[option] ?? false;

  const ServicesSwitchChecks = useSelector(
    state => state.quickQuoteServicesSlice
  );
  let PersistedPaymentType = SelectedRates?.paymentType;
  const ClassDimBtn = useSelector(state => state.classDimensionsBtn);
  const TotalClassPersistedWeight = useSelector(
    state => state.totalPersistedWeightLBS.ClassWeight
  );
  const TotalDimensionsPersistedWeight = useSelector(
    state => state.totalPersistedWeightLBS.DimensionsWeight
  );
  const selectedTableRowID = props?.location.state;
  const dispatch = useDispatch();

  const classes = useStyles();
  const [shipLocationValue, setShipLocationValue] = useState(
    SelectedRates?.location
      ? SelectedRates?.location
      : quickQuoteTLRates?.location
        ? quickQuoteTLRates?.location
        : ''
  );
  const [city, setCity] = useState(
    quickQuoteTLRates?.defaultLocation ? quickQuoteTLRates?.defaultLocation : ''
  );

  const [insidePickupSwitch, setInsidePickupSwitch] = useState(
    getPickupOption('inside')
  );
  const [liftgatePickupSwitch, setLiftgatePickupSwitch] = useState(
    getPickupOption('liftGateServices')
  );
  const [residentialPickupSwitch, setResidentialPickupSwitch] = useState(
    getPickupOption('residential')
  );
  const [limitedPickupAccessSwitch, setLimitedPickupAccessSwitch] = useState(
    getPickupOption('limitedAccess')
  );
  const [secureAccesPickupSwitch, setSecureAccesPickupSwitch] = useState(
    getPickupOption('secureAccess')
  );
  const [freezeProtectionPickupSwitch, setFreezeProtectionPickupSwitch] =
    useState(getPickupOption('freezeProtection'));
  const [overlengthPickupSwitch, setOverlengthPickupSwitch] = useState(
    getPickupOption('overLength')
  );

  const [insideDeliverySwitch, setInsideDeliverySwitch] = useState(
    getDeliveryOption('inside')
  );
  const [liftgateDeliverySwitch, setLiftgateDeliverySwitch] = useState(
    getDeliveryOption('liftGateServices')
  );
  const [residentialDeliverySwitch, setResidentialDeliverySwitch] = useState(
    getDeliveryOption('residential')
  );
  const [limitedDeliverySwitch, setLimitedDeliverySwitch] = useState(
    getDeliveryOption('limitedAccess')
  );
  const [secureAccesDeliverySwitch, setSecureAccesDeliverySwitch] = useState(
    getDeliveryOption('secureAccess')
  );

  const [
    callBeforeDeliveryServicesSwitch,
    setCallBeforeDeliveryServicesSwitch
  ] = useState(getDeliveryOption('callBeforeDelivery'));

  const LTLPaymentTypeArr = [
    'Outbound Prepaid',
    'Inbound Collect',
    'Third Party'
  ];
  const parcelPaymentTypeArr = ['Sender', 'Receiver', 'Third Party'];
  const [hazmatSwitch, setHazmatSwitch] = useState(
    SelectedRates?.isHazmat ? SelectedRates?.isHazmat : false
  );
  const [quotePermissionArr, setQuotePermissionArr] = useState([]);

  const [servicesOpen, setServicesOpen] = useState(
    !!(
      SelectedRates?.codAmount ||
      SelectedRates?.declaredValue ||
      insidePickupSwitch ||
      liftgatePickupSwitch ||
      residentialPickupSwitch ||
      limitedPickupAccessSwitch ||
      secureAccesPickupSwitch ||
      freezeProtectionPickupSwitch ||
      overlengthPickupSwitch ||
      insideDeliverySwitch ||
      liftgateDeliverySwitch ||
      residentialDeliverySwitch ||
      limitedDeliverySwitch ||
      secureAccesDeliverySwitch ||
      callBeforeDeliveryServicesSwitch
    )
  );
  const [pickUpChecked, setPickUpChecked] = useState(false);
  const [overLengthValue, setOverLengthValue] = useState('');
  const [deliveryChecked, setDeliveryChecked] = useState(false);
  const [shipmentDate, setShipmentDate] = useState(new Date());
  const [deliveryDate, setDeliveryDate] = useState('');
  const [deliveryDateError, setDeliveryDateError] = useState(false);
  const DataToShow = viewShipmentsData.ShipmentDetails[selectedTableRowID];
  const [shipFromloading, setShipFromloading] = useState(false);
  const [shipToloading, setShipToloading] = useState(false);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);

  const ShipTypeArr = useMemo(() => {
    if (UserIsAdmin) {
      return ['LTL', 'TL', 'Parcel', 'LTL/Parcel'];
    } else {
      const arr = [];

      if (quotePermissionArr?.some(p => p.level1)) {
        arr.push('LTL');
      }

      if (quotePermissionArr?.some(p => p.level2)) {
        arr.push('TL');
      }
      if (quotePermissionArr?.some(p => p.level3)) {
        arr.push('Parcel');
      }

      if (quotePermissionArr?.some(p => p.level4)) {
        arr.push('LTL/Parcel');
      }

      return arr;
    }
  }, [quotePermissionArr]);

  const [, setGoogleQuery] = useState('');

  const LTLUnitTypeArr = useMemo(
    () => ['Pallet', 'Tote', 'Box', 'Drum', 'Pail', 'Other'],
    []
  ); // eslint-disable-line react-hooks/exhaustive-deps
  const ParcelUnitTypeArr = [
    'Box',
    'Envelope',
    'Large Box',
    'Extra Large Box',
    'Small Box'
  ];

  const [shipTypeValue, setShipTypeValue] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [TLValidationErrors, setTLValidationErrors] = useState([]);
  const [tempError, setTempError] = useState('');
  const [shipLocation, setShipLocation] = useState([]);
  const [userLocationsArr, setUserLocationsArr] = useState([]);
  const [shipLocationLoader, setShipLocationLoader] = useState(false);
  const [, setIsClearing] = useState(false);
  const [shipLocationID, setShipLocationID] = useState(
    SelectedRates?.locationId ? SelectedRates.locationId : 0
  );
  const [paymentTypeValue, setPaymentTypeValue] = useState(
    PersistedPaymentType === '0'
      ? 'Outbound Prepaid'
      : PersistedPaymentType === '1'
        ? 'Inbound Collect'
        : PersistedPaymentType === '2'
          ? 'Third Party'
          : 'Outbound Prepaid'
  );
  const [finalCommodityInfoApi, setFinalCommodityInfoApi] = useState(
    SelectedRates?.commodityInfo ? SelectedRates?.commodityInfo : []
  );
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const ClassArray = useMemo(
    () => [
      '50',
      '55',
      '60',
      '65',
      '70',
      '77.5',
      '85',
      '92.5',
      '100',
      '110',
      '125',
      '150',
      '175',
      '200',
      '250',
      '300',
      '400',
      '500'
    ],
    []
  );

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [classArrayValue] = useState(ClassArray[0]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [dimensionsWeightLBS] = useState('');
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [, setDimensionsWeightLBSErr] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [, setNmbOfunitsErr] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [nmbOfunits] = useState('');
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [dimensions] = useState({
    Lenght: '',
    Width: '',
    Height: ''
  });
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [dimensionsValueErr, setDimensionsValueErr] = useState({
    Lenght: false,
    Width: false,
    Height: false
  });
  /* eslint-disable react-hooks/rules-of-hooks */
  const [CODAmount, setCODAmount] = useState(
    SelectedRates?.codAmount ? SelectedRates.codAmount : ''
  );
  const [DeclaredValue, setDeclaredValue] = useState(
    SelectedRates?.declaredValue ? SelectedRates.declaredValue : ''
  );
  const [getRateLoading] = useState(false);
  const [, setSelectClassErr] = useState(false);
  const [dimensionsErr] = useState(false);
  const history = useHistory();
  const { setSlot } = useContext(NavbarSlotContext);

  useEffect(() => {
    setSlot(
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Typography
          variant='subtitle1'
          sx={{ fontWeight: 700, color: '#0f172a', lineHeight: 1.2 }}
        >
          New {shipTypeValue || 'LTL'} Quote
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography
            variant='caption'
            sx={{ color: '#2563eb', cursor: 'pointer', fontWeight: 500 }}
            onClick={() => history.push('/manage-shipments')}
          >
            Home
          </Typography>
          <Typography variant='caption' sx={{ color: '#94a3b8' }}>
            /
          </Typography>
          <Typography variant='caption' sx={{ color: '#64748b' }}>
            Quick Quote
          </Typography>
        </Box>
      </Box>
    );
    return () => setSlot(null);
  }, [shipTypeValue, setSlot]); // eslint-disable-line react-hooks/exhaustive-deps

  const [, setUnitTypeName] = useState('Pallet');
  const [newAddedDimensionsRow, setNewAddedDimensionsRow] = useState([]);
  const [multiPickupRows, setMultiPickupRows] = useState([]);
  const [multiDropsRows, setMultiDropsRows] = useState([]);
  const [grossWeightError, setGrossWeightError] = useState('');
  const [showWeightError, setShowWeightError] = useState(false);

  const [pickupRemarks, setPickupRemarks] = useState(
    quickQuoteTLRates?.pickupInstructions
      ? quickQuoteTLRates?.pickupInstructions
      : ''
  );
  const [deliveryRemarks, setDeliveryRemarks] = useState(
    quickQuoteTLRates?.deliveryInstructions
      ? quickQuoteTLRates?.deliveryInstructions
      : ''
  );

  const [multiDropsErrors, setMultiDropsErrors] = useState([]);
  const [newAddedClassRow, setNewAddedClassRow] = useState([]);
  const [totalLBSWeightClass, setTotalLBSWeightClass] = useState('');

  const [, setTotalLBSWeightDimensions] = useState('');
  const [totalDeliveryGrossWeight, setTotalDeliveryGrossWeight] = useState('');
  const [totalDimensionsWeightSum, setTotalDimensionsWeightSum] = useState(
    TotalDimensionsPersistedWeight
  );
  const [, setTotalClassWeightSum] = useState(TotalClassPersistedWeight);

  const [alignment] = useState(ClassDimBtn ? ClassDimBtn : 'Class');
  const [, setIsOverLength] = useState(false);
  const TLequipmentArr = [
    'Reefer',
    'Bulk Tanker',
    'Dry Van 53ft',
    'Box Truck',
    'Sprinter',
    'Intermodal'
  ];
  const ShipFrom = [
    SelectedRates?.shipFrom?.city ?? '',
    SelectedRates?.shipFrom?.stateOrProvinceCode ?? '',
    SelectedRates?.shipFrom?.postalCode ?? '',
    SelectedRates?.shipFrom?.countryCode ?? ''
  ]
    .join(' ')
    .trim();

  const ShipTo = [
    SelectedRates?.shipTo?.city ?? '',
    SelectedRates?.shipTo?.stateOrProvinceCode ?? '',
    SelectedRates?.shipTo?.postalCode ?? '',
    SelectedRates?.shipTo?.countryCode ?? ''
  ]
    .join(' ')
    .trim();
  const UserLoggedInEmail = useSelector(state => state.userDetails.email);
  const [locationHoveredValue, setLocationHoveredValue] = useState(null);
  const [locationInputChange, setLocationInputChange] = useState(false);
  const [paymentTypeHoveredValue, setPaymentTypeHoveredValue] = useState(null);
  const [, setPaymentTypeInputChange] = useState(false);
  const [shipFromHoveredValue, setShipFromHoveredValue] = useState(null);
  const [shipToHoveredValue, setShipToHoveredValue] = useState(null);
  const [TLPickupMode, setTLPickupMode] = useState(
    quickQuoteTLRates?.TLPickupMode
      ? quickQuoteTLRates?.TLPickupMode
      : '1 Pickup - 1 Drop'
  );
  const [TLequipmentType, setTLequipmentType] = useState(
    quickQuoteTLRates?.equipmentType
      ? quickQuoteTLRates?.equipmentType
      : TLequipmentArr[2]
  );
  const [TLDriverType, setTLDriverType] = useState(
    quickQuoteTLRates?.serviceType ? quickQuoteTLRates?.serviceType : 'Solo'
  );
  const [temperature, setTemperature] = useState(
    quickQuoteTLRates?.temperature ? quickQuoteTLRates?.temperature : ''
  );
  const [unit, setUnit] = useState(
    quickQuoteTLRates?.unit ? quickQuoteTLRates?.unit : 'Â°C'
  ); // default unit
  const [selectedLocation, setSelectedLocation] = useState(SelectedLoc || '');
  const [freightClassHoveredValue, setFreightClassHoveredValue] =
    useState(null);
  const [unitTypeHoveredValue, setUnitTypeHoveredValue] = useState(null);
  const [openShipFrom, setOpenShipFrom] = useState(false);
  const [openShipTo, setOpenShipTo] = useState(false);
  const [totalGrossWeight, setTotalGrossWeight] = useState();
  const [selectedOptions, setSelectedOptions] = useState('');
  const selectedLocDetails = userLocationsArr?.filter(
    items => items.id === shipLocationID
  );

  useEffect(() => {
    const loc = selectedLocDetails?.[0];
    if (!loc) return;

    if (skipContactAutoPopulate.current) {
      skipContactAutoPopulate.current = false;
      return;
    }

    if (paymentTypeValue === 'Outbound Prepaid') {
      setOriginDetails({
        city: loc.city || '',
        state: loc.stateOrProvinceCode || '',
        zip: loc.postalCode || '',
        country: loc.countryCode || 'USA',
        streetLines: loc.streetLines || '',
        company: loc.companyName || ''
      });
      setOriginContactName(loc.contactName || '');
      setOriginContactEmail(loc.contactEmail?.split(',')[0]?.trim() || '');
      setOriginContactPhone(loc.contactPhone || '');
    } else if (paymentTypeValue === 'Inbound Collect') {
      setDestinationDetails({
        city: loc.city || '',
        state: loc.stateOrProvinceCode || '',
        zip: loc.postalCode || '',
        country: loc.countryCode || 'USA',
        streetLines: loc.streetLines || '',
        company: loc.companyName || ''
      });
      setDestinationContactName(loc.contactName || '');
      setDestinationContactEmail(loc.contactEmail?.split(',')[0]?.trim() || '');
      setDestinationContactPhone(loc.contactPhone || '');
    }
  }, [paymentTypeValue, shipLocationID]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // Only set initial value if not already set
    if (!shipTypeValue) {
      const initialValue =
        quickQuoteTLRates?.shipmentType ||
        SelectedRates?.shipmentType ||
        (ShipTypeArr.length > 0 ? ShipTypeArr[0] : '');

      setShipTypeValue(initialValue);
      setSelectedOptions(initialValue);
    }
  }, [ShipTypeArr]); // Only depend on ShipTypeArr for initial setup

  // Separate effect for quickQuoteTLRates changes
  useEffect(() => {
    if (quickQuoteTLRates?.shipmentType) {
      setShipTypeValue(quickQuoteTLRates.shipmentType);
      setSelectedOptions(quickQuoteTLRates.shipmentType);
    }
  }, [quickQuoteTLRates]);

  // Separate effect for SelectedRates changes
  useEffect(() => {
    if (SelectedRates?.shipmentType && !quickQuoteTLRates?.shipmentType) {
      setShipTypeValue(SelectedRates.shipmentType);
      setSelectedOptions(SelectedRates.shipmentType);
    }
  }, [SelectedRates]);

  const isReefer = TLequipmentType === 'Reefer' ? true : false;

  useEffect(() => {
    if (props?.location?.state?.locationType === 'quickQuote') {
      setShipLocationValue(shipLocation[0]?.location?.split(': ')[1] || '');
      setSelectedLocation(shipLocation[0] || '');
      setShipLocationID(shipLocation[0]?.id);
    }
  }, [props?.location?.state?.locationType, shipLocation]);

  useEffect(() => {
    if (!shipLocationValue) return;
    const parsedAddress = parseAddress(shipLocationValue);
    const City = parsedAddress.city;
    const State = parsedAddress.state;
    const ZipCode = parsedAddress.zip;
    const CountryCode = parsedAddress.countryCode;
    if (paymentTypeValue === 'Outbound Prepaid') {
      setMultiPickupRows(prev =>
        prev.map((row, i) =>
          i === 0
            ? {
                ...row,
                pickupAddress: shipLocationValue ?? '',
                city: City ?? '',
                state: State ?? '',
                zip: ZipCode ?? '',
                country: CountryCode ?? '',
                address: selectedLocDetails[0]?.streetLines,
                company: selectedLocDetails[0]?.companyName ?? '',
                email:
                  selectedLocDetails[0]?.contactEmail?.split(',')[0].trim() ??
                  '',
                contactName: selectedLocDetails[0]?.contactName ?? '',
                phone: selectedLocDetails[0]?.contactPhone ?? ''
              }
            : row
        )
      );
    }
    if (paymentTypeValue === 'Inbound Collect') {
      setMultiDropsRows(prev =>
        prev.map((row, i) =>
          i === 0
            ? {
                ...row,
                dropAddress: shipLocationValue ?? '',
                city: City ?? '',
                state: State ?? '',
                zip: ZipCode ?? '',
                country: CountryCode ?? '',
                address: selectedLocDetails[0]?.streetLines,
                company: selectedLocDetails[0]?.companyName ?? '',
                email:
                  selectedLocDetails[0]?.contactEmail?.split(',')[0].trim() ??
                  '',
                contactName: selectedLocDetails[0]?.contactName ?? '',
                phone: selectedLocDetails[0]?.contactPhone ?? ''
              }
            : row
        )
      );
    }
  }, [shipLocationValue, paymentTypeValue, TLPickupMode]);

  const convertFlatToMultiDropRows = (
    apiDeliveryLineItems = [],
    LTLUnitTypeArr,
    shipTypeValue
  ) => {
    if (!Array.isArray(apiDeliveryLineItems))
      return { grouped: [], flatMapped: [] };

    const groupedByAddress = {};

    apiDeliveryLineItems.forEach(item => {
      const key = `${item.address}_${item.city}_${item.zip}`;
      if (!groupedByAddress[key]) {
        groupedByAddress[key] = [];
      }
      groupedByAddress[key].push(item);
    });

    const grouped = Object.values(groupedByAddress).map(group => {
      const firstItem = group[0];
      return {
        dropAddress: firstItem?.dropAddress || '',
        expDropDeliveryDate: new Date(firstItem?.expectedDeliveryDate) || '',
        deliveryOpenHours: firstItem?.openTime || '',
        deliveryCloseHours: firstItem?.closeTime || '',
        deliveryInstructions: firstItem?.deliveryInstructions,
        company: firstItem.company || '',
        address: firstItem.address || '',
        city: firstItem.city || '',
        state: firstItem.state || '',
        zip: firstItem.zip || '',
        country: firstItem.country || '',
        email: firstItem?.email ?? '',
        phone: firstItem?.phone ?? '',
        contactName: firstItem?.contactName ?? '',
        deliveryLineItems: group.map(item => {
          return {
            itemText: item?.itemText || '',
            Class: item.freightClass || '50',
            WeightLBS: item.netWeight?.toString() || '',
            GrossWeight: item.grossWeight?.toString() || '',
            UnitTypeValue: item.packagingType || LTLUnitTypeArr?.[0] || '',
            nmfc: item.nmfcClass || '',
            NmbOfUnits: item.pallets?.toString() || '1',
            Pieces: item.requestedQuantity?.toString() || '1',
            StackAble: item.isStackable ?? false,
            isHazmat: item.isHazmat ?? false,
            Length: item.length || 0,
            Width: item.width || 0,
            Height: item.height || 0
          };
        })
      };
    });

    return Object.values(grouped);
  };

  const convertFlatToMultiPickupRows = (apiFlatPickupLineItems = []) => {
    const grouped = {};

    apiFlatPickupLineItems.forEach(item => {
      const key = `${item.address}_${item.city}_${item.zip}`;
      if (!grouped[key]) {
        grouped[key] = {
          pickupAddress: item.pickupAddress || '',
          pickupDate: new Date(item.pickupDate) || '',
          expPickDeliveryDate: new Date(item.expectedDeliveryDate) || '',
          pickupOpenHours: item.openTime || '',
          pickupCloseHours: item.closeTime || '',
          isHazmat: item.isHazmat,
          pickupInstructions: item.pickupInstructions ?? '',
          company: item.company || '',
          address: item.address || '',
          city: item.city || '',
          state: item.state || '',
          zip: item.zip || '',
          country: item.country || '',
          email: item?.email ?? '',
          phone: item?.phone ?? '',
          contactName: item?.contactName ?? '',
          pickupLineItems: []
        };
      }

      grouped[key].pickupLineItems.push({
        itemText: item.itemText || '',
        Class: item.freightClass || '50',
        WeightLBS: item.netWeight?.toString() || '',
        GrossWeight: item.grossWeight?.toString() || '',
        UnitTypeValue: item.packagingType || '',
        nmfc: item.nmfcClass || '',
        NmbOfUnits: item.pallets?.toString() || '1',
        Pieces: item.requestedQuantity?.toString() || '1',
        StackAble: item.isStackable ?? false,
        Length: item.length || 0,
        Width: item.width || 0,
        Height: item.height || 0
      });
    });
    return Object.values(grouped);
  };
  useEffect(() => {
    const hasPickupData = quickQuoteTLRates?.pickupLineItems?.length > 0;
    const hasDropData = quickQuoteTLRates?.deliveryLineItems?.length > 0;

    if (hasPickupData || hasDropData) {
      if (hasPickupData) {
        const multiPickupRows = convertFlatToMultiPickupRows(
          quickQuoteTLRates.pickupLineItems
        );
        setMultiPickupRows(multiPickupRows);
      }

      if (hasDropData) {
        const multiDropsRows = convertFlatToMultiDropRows(
          quickQuoteTLRates.deliveryLineItems
        );
        setMultiDropsRows(multiDropsRows);
      }
    } else {
      // Set default values only when there's no API data
      setMultiDropsRows([
        {
          dropAddress: '',
          itemText: '',
          expDropDeliveryDate: deliveryDate,
          deliveryOpenHours: deliveryOpenTimeValue,
          deliveryCloseHours: deliveryCloseTimeValue,
          deliveryInstructions: '',
          company: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          country: '',

          deliveryLineItems: [
            {
              itemText: '',
              Class: '50',
              WeightLBS: '',
              GrossWeight: '',
              UnitTypeValue: 'Pallet',
              nmfc: '',
              NmbOfUnits: '1',
              Pieces: '1',
              StackAble: false,
              Length: 0,
              Width: 0,
              Height: 0
            }
          ]
        }
      ]);

      setMultiPickupRows([
        {
          pickupAddress: '',
          pickupDate: shipmentDate,
          expPickDeliveryDate: '',
          pickupOpenHours: originOpenTimeValue,
          pickupCloseHours: originCloseTimeValue,
          pickupInstructions: '',
          isHazmat: false,
          company: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          country: '',
          pickupLineItems: [
            {
              itemText: '',
              Class: '50',
              WeightLBS: '',
              GrossWeight: '',
              UnitTypeValue: 'Pallet',
              nmfc: '',
              NmbOfUnits: '1',
              Pieces: '1',
              StackAble: false,
              Length: 0,
              Width: 0,
              Height: 0
            }
          ]
        }
      ]);
    }
  }, [
    quickQuoteTLRates?.pickupLineItems,
    quickQuoteTLRates?.deliveryLineItems
  ]);

  const handleClearForm = () => {
    setIsClearing(true);
    // addresses
    setShipFromFinalAddress('');
    setShipFromFinalValue('');
    setShipToFinalAddress('');
    setShipToFinalValue('');
    setOriginDetails(null);
    setDestinationDetails(null);
    setOriginContactName('');
    setOriginContactEmail('');
    setOriginContactPhone('');
    setDestinationContactName('');
    setDestinationContactEmail('');
    setDestinationContactPhone('');
    setOriginOpenTimeValue(dayjs('2024-02-17T08:00').format('HH:mm'));
    setOriginCloseTimeValue(dayjs('2024-02-17T16:00').format('HH:mm'));
    setDeliveryOpenTimeValue(dayjs('2024-02-17T08:00').format('HH:mm'));
    setDeliveryCloseTimeValue(dayjs('2024-02-17T16:00').format('HH:mm'));
    // location
    setShipLocationID('');
    setShipLocationValue('');
    setLocationHoveredValue('');
    setSelectedLocation('');
    // payment & remarks
    setPaymentTypeValue('Outbound Prepaid');
    setPickupRemarks('');
    setDeliveryRemarks('');
    // dates
    setShipmentDate(new Date());
    setDeliveryDate('');
    setDeliveryDateError(false);
    // accessorials
    setPickUpChecked(false);
    setDeliveryChecked(false);
    setInsidePickupSwitch(false);
    setLiftgatePickupSwitch(false);
    setResidentialPickupSwitch(false);
    setLimitedPickupAccessSwitch(false);
    setSecureAccesPickupSwitch(false);
    setFreezeProtectionPickupSwitch(false);
    setOverlengthPickupSwitch(false);
    setInsideDeliverySwitch(false);
    setLiftgateDeliverySwitch(false);
    setResidentialDeliverySwitch(false);
    setLimitedDeliverySwitch(false);
    setSecureAccesDeliverySwitch(false);
    setCallBeforeDeliveryServicesSwitch(false);
    setHazmatSwitch(false);
    setOverLengthValue('');
    // commodity / weight
    setCODAmount('');
    setDeclaredValue('');
    setTotalLBSWeightClass('');
    setTotalDeliveryGrossWeight('');
    setTotalDimensionsWeightSum(0);
    setTotalGrossWeight(0);
    setGrossWeightError('');
    setShowWeightError(false);
    setNewAddedDimensionsRow([
      {
        Class: '50',
        itemText: '',
        WeightLBS: '',
        GrossWeight: '',
        UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
        nmfc: '',
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: 0,
        Width: 0,
        Height: 0
      }
    ]);
    setNewAddedClassRow([
      {
        WeightLBS: '',
        Class: ClassArray?.[0] ?? '',
        NMFCnumber: ''
      }
    ]);
    // TL fields
    setTLequipmentType(TLequipmentArr[2]);
    setTLPickupMode('1 Pickup - 1 Drop');
    setTemperature('');
    setUnit('Â°C');
    // validation errors
    setValidationErrors({});
    setTLValidationErrors([]);
    setTempError('');
    setMultiDropsErrors([]);
    // multi-stop rows
    setMultiPickupRows([
      {
        pickupAddress: '',
        pickupDate: new Date(),
        expPickDeliveryDate: '',
        pickupOpenHours: originOpenTimeValue,
        pickupCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        pickupLineItems: [
          {
            itemText: '',
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: 'Pallet',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
    setMultiDropsRows([
      {
        dropAddress: '',
        itemText: '',
        expDropDeliveryDate: '',
        deliveryOpenHours: originOpenTimeValue,
        deliveryCloseHours: originCloseTimeValue,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        deliveryLineItems: [
          {
            itemText: '',
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
    // redux
    dispatch(setQuickQuotePickUpCheckedRedux(false));
    dispatch(setQuickQuoteDeliveryCheckedRedux(false));
    dispatch(setClassWeight(''));
    dispatch(setDimensionsWeight(''));
    dispatch(setQuickQuoteTLRateValues({}));
    dispatch(setQuickQuoteRateLoc(''));
    dispatch(setQuickQuoteRateValues({}));
    setIsClearing(false);
  };

  useEffect(() => {
    setNewAddedDimensionsRow([
      {
        Class: '50',
        itemText: '',
        WeightLBS: '',
        GrossWeight: '',
        UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
        nmfc: '',
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: 0,
        Width: 0,
        Height: 0
      }
    ]);
    setNewAddedClassRow([
      {
        WeightLBS: '',
        Class: ClassArray?.[0] ?? '',
        NMFCnumber: ''
      }
    ]);
  }, []);

  // Add another useEffect for handling page refresh
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Clear the values when the page is being refreshed
      dispatch(setQuickQuoteRateValues(''));
      dispatch(setQuickQuoteRateLoc(''));
      dispatch(setQuickQuotePickUpCheckedRedux(false));
      dispatch(setQuickQuoteDeliveryCheckedRedux(false));
      // dispatch(setClassDimensionsButton(alignment));
      // dispatch(setClassRows(newAddedClassRow));
      // dispatch(setDimensionRows(newAddedDimensionsRow));
      dispatch(setClassWeight(''));
      dispatch(setDimensionsWeight(''));
    };

    // Attach the beforeunload event listener
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup function for removing the event listener
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const didInit = useRef(false);
  const skipContactAutoPopulate = useRef(
    !!(
      SelectedRates?.originContactName || SelectedRates?.destinationContactName
    )
  );

  useEffect(() => {
    if (
      didInit.current ||
      !SelectedRates ||
      !Array.isArray(SelectedRates?.commodityInfo) ||
      SelectedRates?.commodityInfo.length === 0 ||
      !LTLUnitTypeArr?.length ||
      !ClassArray?.length
    ) {
      return;
    }

    didInit.current = true; // âœ… Prevent rerun

    const commodity = SelectedRates.commodityInfo[0];
    const dimensions = commodity?.dimensions || {};
    const pickupOptions = SelectedRates?.pickupOptions || {};
    const selectedLocationVal = SelectedRates?.location || '';

    setNewAddedDimensionsRow([
      {
        Class: commodity?.freightClass ?? '50',
        itemText: commodity?.itemText ?? '',
        WeightLBS: commodity?.weight?.value ?? '',
        GrossWeight: commodity?.grossWeight ?? '',
        UnitTypeValue: commodity?.packaging ?? LTLUnitTypeArr[0],
        nmfc: '',
        NmbOfUnits: commodity?.units ?? commodity?.pallets ?? '1',
        Pieces: commodity?.pieces ?? '1',
        StackAble: commodity?.isStackable ?? dimensions?.isStackable ?? false,
        Length: dimensions?.length ?? 0,
        Width: dimensions?.width ?? 0,
        Height: dimensions?.height ?? 0
      }
    ]);

    setNewAddedClassRow([
      {
        WeightLBS: commodity?.weight?.value ?? '',
        Class: ClassArray[0],
        NMFCnumber: ''
      }
    ]);

    setIsOverLength(pickupOptions.overLength ?? false);
    setOverLengthValue(pickupOptions.overLengthValue ?? '');
    setTotalGrossWeight(TotalClassPersistedWeight);
    setSelectedOptions(
      quickQuoteTLRates?.shipmentType
        ? quickQuoteTLRates?.shipmentType
        : SelectedRates?.shipmentType
          ? SelectedRates?.shipmentType
          : 'LTL'
    );
    setShipLocationValue(selectedLocationVal);
    const cleanShipFrom = ShipFrom.includes('undefined') ? '' : ShipFrom;
    const cleanShipTo = ShipTo.includes('undefined') ? '' : ShipTo;

    setShipFromFinalValue(cleanShipFrom);
    setShipToFinalValue(cleanShipTo);

    if (paymentTypeValue === 'Outbound Prepaid') {
      setShipFromFinalAddress(selectedLocationVal);
    } else if (cleanShipFrom) {
      const p = parseAddress(cleanShipFrom);
      if (p.city) {
        setShipFromFinalAddress({
          City: p.city,
          State: p.state,
          ZipCode: p.zip,
          CountryCode: p.countryCode
        });
        setOriginDetails({
          city: p.city,
          state: p.state,
          zip: p.zip,
          country: p.countryCode,
          streetLines: ''
        });
      }
    }

    if (['Inbound Collect', 'Receiver'].includes(paymentTypeValue)) {
      setShipToFinalAddress(selectedLocationVal);
    } else if (cleanShipTo) {
      const p = parseAddress(cleanShipTo);
      if (p.city) {
        setShipToFinalAddress({
          City: p.city,
          State: p.state,
          ZipCode: p.zip,
          CountryCode: p.countryCode
        });
        setDestinationDetails({
          city: p.city,
          state: p.state,
          zip: p.zip,
          country: p.countryCode,
          streetLines: ''
        });
      }
    }

    setDeliveryDate(
      SelectedRates.deliveryDate ? new Date(SelectedRates.deliveryDate) : ''
    );

    setShipmentDate(
      SelectedRates.shipmentDate
        ? new Date(SelectedRates.shipmentDate)
        : new Date()
    );

    setPickUpChecked(ServicesSwitchChecks?.QuickQuotePickUpCheckedRedux ?? '');
    setDeliveryChecked(
      ServicesSwitchChecks?.QuickQuoteDeliveryCheckedRedux ?? false
    );
  }, [
    ClassArray,
    quickQuoteTLRates,
    LTLUnitTypeArr,
    SelectedLoc,
    TotalClassPersistedWeight,
    ServicesSwitchChecks,
    SelectedRates,
    paymentTypeValue,
    ShipTo,
    shipLocationValue,
    ShipFrom
  ]);

  useEffect(() => {
    setOpenShipFrom(false);
    setOpenShipTo(false);

    let ToalWeightLBS = 0;
    if (AddedClassRows) {
      for (let i = 0; i < AddedClassRows.length; i++) {
        ToalWeightLBS += parseInt(AddedClassRows[i].WeightLBS);
      }
      setTotalLBSWeightClass(ToalWeightLBS);
    }
  }, []);

  useEffect(() => {
    let ToalWeightLBS = 0;
    if (AddedDimensionsRows) {
      for (let i = 0; i < AddedDimensionsRows.length; i++) {
        ToalWeightLBS += parseInt(AddedDimensionsRows[i].WeightLBS);
      }
      setTotalLBSWeightDimensions(ToalWeightLBS);
    }
  }, []);

  const [carrierApiNames] = useState([]);
  const [ParcelCarrierApiNames] = useState([]);
  const [userPermissionsArr, setUserPermissionsArr] = useState([]);

  useEffect(() => {
    if (SelectedRates?.commodityInfo?.[0]?.weight?.value) {
      const copy1 = JSON.parse(JSON.stringify(AddedClassRows));
      setNewAddedClassRow(copy1);
      const copy2 = JSON.parse(JSON.stringify(AddedDimensionsRows));

      setNewAddedDimensionsRow(copy2);

      if (alignment === 'Dimensions') {
        setTotalDimensionsWeightSum(
          parseInt(SelectedRates.commodityInfo[0]?.weight?.value)
        );
      }

      if (alignment === 'Class') {
        setTotalClassWeightSum(
          parseInt(SelectedRates.commodityInfo[0]?.weight?.value)
        );
      }
    }
    if (
      !ShipFrom.includes('undefined') &&
      (paymentTypeValue === 'Third Party' ||
        paymentTypeValue === 'Inbound Collect')
    ) {
      const p = parseAddress(ShipFrom);
      if (p.city) {
        setShipFromFinalAddress({
          City: p.city,
          State: p.state,
          ZipCode: p.zip,
          CountryCode: p.countryCode
        });
        setOriginDetails({
          city: p.city,
          state: p.state,
          zip: p.zip,
          country: p.countryCode,
          streetLines: ''
        });
      }
    }

    if (
      !ShipTo.includes('undefined') &&
      paymentTypeValue !== 'Inbound Collect'
    ) {
      const p = parseAddress(ShipTo);
      if (p.city) {
        setShipToFinalAddress({
          City: p.city,
          State: p.state,
          ZipCode: p.zip,
          CountryCode: p.countryCode
        });
        setDestinationDetails({
          city: p.city,
          state: p.state,
          zip: p.zip,
          country: p.countryCode,
          streetLines: ''
        });
      }
    }
  }, []);

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Locations'
    );

    const filteredQuotePermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Quick Quote'
    );

    setUserPermissionsArr(filteredCarrierPermissions);
    setQuotePermissionArr(filteredQuotePermissions);
  }, [userRolePermissions]);

  const handleGetRates = e => {
    e.preventDefault();
    setDeliveryDateError(true);
    setOpenShipFrom(false);
    if (dimensionsErr) {
      if (!dimensionsWeightLBS) {
        setDimensionsWeightLBSErr(true);
      }
      if (!nmbOfunits) {
        setNmbOfunitsErr(true);
      }
      if (!dimensions.Lenght) {
        setDimensionsValueErr({ ...dimensionsValueErr, Lenght: true });
      }
      if (!dimensions.Width) {
        setDimensionsValueErr({ ...dimensionsValueErr, Width: true });
      }
      if (!dimensions.Height) {
        setDimensionsValueErr({ ...dimensionsValueErr, Height: true });
      }
    }
    if (!classArrayValue) {
      setSelectClassErr(true);
    } else if (classArrayValue) {
      setSelectClassErr(false);
      // setGetRateLoading(true);
      let ApiCityFrom = originDetails?.city || '';
      let ApiStateFrom = originDetails?.state || '';
      let ApiZipFrom = originDetails?.zip || '';
      let ApiZipFromCountryCode = originDetails?.country || '';

      let ApiCityTo = destinationDetails?.city || '';
      let ApiStateTo = destinationDetails?.state || '';
      let ApiZipTo = destinationDetails?.zip || '';
      let ApiZipToCountryCode = destinationDetails?.country || '';
      const selectedLocDetails = userLocationsArr?.filter(
        items => items.id === shipLocationID
      );

      const apiPickupLineItems = [];
      const apiDeliveryLineItems = [];

      let TLquoteObj = {
        id: 0,
        defaultLocation: city,
        carrierId: 0,
        carrierName: '',
        carrierLogo: '',
        invoiceType: '',
        shipmentId: '',
        proNumber: '',
        TLPickupMode: '1 Pickup - 1 Drop',
        temperature: temperature,
        pickupInstructions: cleanHtmlString(pickupRemarks) ?? '',
        deliveryInstructions: cleanHtmlString(deliveryRemarks) ?? '',
        unit: unit,
        orderDate: '',
        pickupDate: '',
        invoiceNumber: '',
        deliveryDate: '',
        ExpectedDeliveryDate: '',
        invoiceDate: '',
        originCompany:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.companyName || ''
            : originDetails?.company || '',
        originAddress:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.streetLines || ''
            : originDetails?.streetLines || '',
        originCity:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.city || ''
            : originDetails?.city || '',
        originState:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.stateOrProvinceCode || ''
            : originDetails?.state || '',
        originZip:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.postalCode || ''
            : originDetails?.zip || '',
        originCountry:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.countryCode || ''
            : originDetails?.country || '',
        originContactPerson: originContactName,
        originContactEmail: originContactEmail,
        originContactPhone: originContactPhone,

        destinationCompany:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.companyName || ''
            : destinationDetails?.company || '',
        destinationAddress:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.streetLines || ''
            : destinationDetails?.streetLines || '',
        destinationCity:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.city || ''
            : destinationDetails?.city || '',
        destinationState:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.stateOrProvinceCode || ''
            : destinationDetails?.state || '',
        destinationZip:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.postalCode || ''
            : destinationDetails?.zip || '',
        destinationCountry:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.countryCode || ''
            : destinationDetails?.country || '',
        destinationContactPerson: destinationContactName,
        destinationContactEmail: destinationContactEmail,
        destinationContactPhone: destinationContactPhone,
        billToCompany: '',
        billToAddress: '',
        billToCity: '',
        billToState: '',
        billToZip: '',
        billToCountry: '',
        shipmentType: 'TL',
        equipmentType: TLequipmentType,
        soNumber: '',
        clientPONumber: '',
        isHazmat: hazmatSwitch || false,
        pickupLineItems: apiPickupLineItems,
        deliveryLineItems: apiDeliveryLineItems,
        pickupNumber: '',
        shipmentStatus: 'Saved',
        cargoValue: '',
        freightTerms: paymentTypeValue.replace(/\s+/g, ''),
        paymentTerms: paymentTypeValue,
        bolNumber: '',
        customerId: '',
        shippingNotes: pickupRemarks,
        billToContactPerson: '',
        billToContactEmail: '',
        billToContactPhone: '',
        locationName: selectedLocation?.location,
        location: shipLocationValue,
        locationId: shipLocationID,
        pickupStartTime: '',
        pickupEndTime: '',
        deliverStartTime: '',
        deliverEndTime: '',
        quoteId: 0,
        shipmentCharges: 0,
        actualPickupDate: '',
        actualDeliveryDate: '',
        sessionId: '',
        quoteNumber: '',
        dispatchInput1: '',
        lastUpdatedOn: '',
        serviceType: TLDriverType,
        totalNetWeight: totalNetWeightLBS ? totalNetWeightLBS : 0,
        totalGrossWeight: totalGrossWeightLBS ? totalGrossWeightLBS : 0,
        originTerminalAddress: '',
        originTerminalCity: '',
        originTerminalState: '',
        originTerminalPostalCode: '',
        originTerminalCountry: '',
        originTerminalContact: '',
        originTerminalContantEmail: '',
        originTerminalContactPhone: '',
        destinationTerminalAddress: '',
        destinationTerminalCity: '',
        destinationTerminalState: '',
        destinationTerminalPostalCode: '',
        destinationTerminalCountry: '',
        destinationTerminalContact: '',
        destinationTerminalContantEmail: '',
        destinationTerminalContactPhone: '',
        pickupOptions: {
          inside: false,
          liftGateServices: false,
          residential: false,
          secureAccess: false,
          limitedAccess: false,
          freezeProtection: false,
          overLength: false,
          callBeforeDelivery: false,
          overLengthValue: 0
        },
        deliveryOptions: {
          inside: false,
          liftGateServices: false,
          residential: false,
          secureAccess: false,
          limitedAccess: false
        },
        pickupOptionsAccessorial: '',
        deliveryOptionAccessorial: '',
        carrierBillToCompany: '',
        carrierBillToAddress: '',
        carrierBillToCity: '',
        carrierBillToState: '',
        carrierBillToZip: '',
        carrierBillToCountry: '',
        carrierBillToContactPerson: '',
        carrierBillToContactEmail: '',
        carrierBillToContactPhone: '',
        surcharges: '',
        surchargesList: '',
        estimatedTransitDays: 0,
        shipmentMiles: calDistanceValue,
        OriginData: '',
        destinationData: '',
        salesOrderNumber: '',
        purchaseOrderNumber: '',
        freightInvoiceNumber: ''
      };
      let obj = {
        shipmentType: shipTypeValue,
        locationFull: selectedLocation.location,
        location: shipLocationValue,
        paymentType:
          paymentTypeValue === 'Outbound Prepaid'
            ? '0'
            : paymentTypeValue === 'Inbound Collect'
              ? '1'
              : '2',
        shipFrom: {
          city: ApiCityFrom,
          stateOrProvinceCode: ApiStateFrom,
          postalCode: ApiZipFrom,
          countryCode: ApiZipFromCountryCode,
          residential: true,
          streetLines:
            paymentTypeValue === 'Outbound Prepaid'
              ? selectedLocDetails[0]?.streetLines
              : ''
        },
        shipTo: {
          city: ApiCityTo,
          stateOrProvinceCode: ApiStateTo,
          postalCode: ApiZipTo,
          countryCode: ApiZipToCountryCode,
          residential: true,
          streetLines:
            paymentTypeValue === 'Inbound Collect'
              ? selectedLocDetails[0]?.streetLines
              : ''
        },
        shipmentDate: new Date(),
        isHazmat: hazmatSwitch,
        commodityInfo: handlePushAddedCommodityInfo(),

        pickupOptions: {
          inside: pickUpChecked ? insidePickupSwitch : false,
          liftGateServices: pickUpChecked ? liftgatePickupSwitch : false,
          residential: pickUpChecked ? residentialPickupSwitch : false,
          secureAccess: pickUpChecked ? secureAccesPickupSwitch : false,
          limitedAccess: pickUpChecked ? limitedPickupAccessSwitch : false,
          freezeProtection: pickUpChecked
            ? freezeProtectionPickupSwitch
            : false,
          overLength: pickUpChecked ? overlengthPickupSwitch : false,
          overLengthValue:
            pickUpChecked && overLengthValue ? parseFloat(overLengthValue) : 0,
          callBeforeDelivery: false
        },
        deliveryOptions: {
          inside: deliveryChecked ? insideDeliverySwitch : false,
          liftGateServices: deliveryChecked ? liftgateDeliverySwitch : false,
          residential: deliveryChecked ? residentialDeliverySwitch : false,
          secureAccess: deliveryChecked ? secureAccesDeliverySwitch : false,
          limitedAccess: deliveryChecked ? limitedDeliverySwitch : false,
          freezeProtection: false,
          overLength: false,
          overLengthValue: 0,
          callBeforeDelivery: deliveryChecked
            ? callBeforeDeliveryServicesSwitch
            : false
        },
        codAmount: CODAmount ? parseInt(CODAmount) : 0,
        declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
        agencyId: AgencyID ? AgencyID : 0,
        isGuaranteed: false,
        locationId: shipLocationID
      };

      let deepClone = JSON.parse(
        JSON.stringify(shipTypeValue === 'TL' ? TLquoteObj : obj)
      );
      validateAutocompletes(
        shipTypeValue === 'TL' ? TLquoteObj : obj,
        deepClone
      );
    }
  };
  const addLocPermission = userPermissionsArr.some(
    permission => permission.level3
  );

  const checkPickupStatus = () => {
    if (pickUpChecked) {
      setInsidePickupSwitch(false);
      setLiftgatePickupSwitch(false);
      setResidentialPickupSwitch(false);
      setSecureAccesPickupSwitch(false);
      setFreezeProtectionPickupSwitch(false);
      setOverlengthPickupSwitch(false);
      setLimitedPickupAccessSwitch(false);
      setIsOverLength(false);

      //   dispatch(setRateValues(obj));
    }
  };
  const checkDeliveryStatus = () => {
    if (deliveryChecked) {
      setInsideDeliverySwitch(false);
      setLiftgateDeliverySwitch(false);
      setResidentialDeliverySwitch(false);
      setSecureAccesDeliverySwitch(false);
      setCallBeforeDeliveryServicesSwitch(false);
      setLimitedDeliverySwitch(false);

      //   dispatch(setRateValues(obj));
    }
  };
  const handleSetShipLocation = arr => {
    const temp = [];
    setUserLocationsArr(arr.assignedLocations);
    const array = arr.assignedLocations;
    for (let i = 0; i < array.length; i++) {
      const Element =
        array[i].name +
        ': ' +
        array[i].city +
        ' ' +
        array[i].stateOrProvinceCode +
        ' ' +
        array[i].postalCode +
        ' ' +
        array[i].countryCode;
      const LocationId = array[i].id;
      temp.push({ location: Element, id: LocationId });
    }
    setShipLocationLoader(false);
    setShipLocation(temp.reverse());
  };

  useEffect(() => {
    setShipLocationLoader(true);
    GetAagencyUserDetails(UserLoggedInEmail)
      .then(res => res.status === 200 && handleSetShipLocation(res.data.data))
      .catch(err => console.log(err));
    // GetLocations(AgencyID)
    //   .then(res => res.status === 200 && handleSetShipLocation(res.data.data))
    //   .catch(err => console.log(err));
  }, []);

  const handleCheckAddedRow = () => {};
  const handleKeyPress = event => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  const getFreightClassFromDensity = density => {
    if (density >= 50) return '50';
    if (density >= 35) return '55';
    if (density >= 30) return '60';
    if (density >= 22.5) return '65';
    if (density >= 15) return '70';
    if (density >= 13.5) return '77.5';
    if (density >= 12) return '85';
    if (density >= 10.5) return '92.5';
    if (density >= 9) return '100';
    if (density >= 8) return '110';
    if (density >= 7) return '125';
    if (density >= 6) return '150';
    if (density >= 5) return '175';
    if (density >= 4) return '200';
    if (density >= 2) return '250';
    return '300';
  };
  const handleDimensionsInputChange = (inputName, index, event, type) => {
    var filteredClass = [];
    var filteredUnitType = [];

    let totalWeight = 0;
    let TotalWeightSum;
    const maxLimit = 14999;
    const maxLimitParcel = 150;
    const values = [...newAddedDimensionsRow];
    if (inputName === 'WeightLBS') {
      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      if (shipTypeValue === 'Parcel') {
        if (parseInt(inputValue, 10) > maxLimitParcel) {
          const updatedErrors = {
            ...validationErrors,
            [`weightEr${index}`]: 'Maximum weight limit is 150 lbs'
          };
          setValidationErrors(updatedErrors);
        } else {
          const updatedErrors = {
            ...validationErrors,
            [`weightEr${index}`]: null
          };
          setValidationErrors(updatedErrors);
          values[index].WeightLBS = inputValue;

          for (let index = 0; index < newAddedDimensionsRow.length; index++) {
            if (newAddedDimensionsRow[index].WeightLBS !== '') {
              totalWeight += parseInt(newAddedDimensionsRow[index].WeightLBS);
            }
          }
          setTotalLBSWeightDimensions(totalWeight);
          TotalWeightSum = totalLBSWeightClass
            ? parseInt(totalLBSWeightClass) + totalWeight
            : totalWeight;
          setTotalDimensionsWeightSum(totalWeight);
          handlePushAddedCommodityInfo(totalWeight);
        }
      } else if (
        shipTypeValue !== 'TL' &&
        parseInt(inputValue, 10) > maxLimit
      ) {
        const updatedErrors = {
          ...validationErrors,
          [`weightEr${index}`]: 'Maximum weight limit is 14999'
        };
        setValidationErrors(updatedErrors);
      } else {
        const updatedErrors = {
          ...validationErrors,
          [`weightEr${index}`]: null
        };
        setValidationErrors(updatedErrors);
        values[index].WeightLBS = inputValue;

        for (let index = 0; index < newAddedDimensionsRow.length; index++) {
          if (newAddedDimensionsRow[index].WeightLBS !== '') {
            totalWeight += parseInt(newAddedDimensionsRow[index].WeightLBS);
          }
        }
        setTotalLBSWeightDimensions(totalWeight);
        TotalWeightSum = totalLBSWeightClass
          ? parseInt(totalLBSWeightClass) + totalWeight
          : totalWeight;
        setTotalDimensionsWeightSum(totalWeight);
        handlePushAddedCommodityInfo(totalWeight, 'totalWeight');
      }
    } else if (inputName === 'Class') {
      if (!values[index]) {
        values[index] = {};
      }
      values[index].Class = event;
    } else if (inputName === 'GrossWeight') {
      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      // if (!isNaN(inputValue) && parseFloat(inputValue) > 0) {
      values[index].GrossWeight = inputValue;
      const totalGrossWeight = values.reduce(
        (sum, item) => sum + Number(item.GrossWeight || 0),
        0
      );
      setTotalGrossWeight(totalGrossWeight);
      // const updatedErrors = {
      //   ...validationErrors,
      //   numberOfUnits: null
      // };
      // setValidationErrors(updatedErrors);
      // }
    } else if (inputName === 'NmbOfUnits') {
      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      handlePushAddedCommodityInfo(inputValue, 'NmbOfUnits');
      // if (parseInt(inputValue, 10) >= 0) {
      //   values[index].NmbOfUnits = inputValue;
      // }
      if (!isNaN(inputValue) && parseFloat(inputValue) > 0) {
        values[index].NmbOfUnits = inputValue;
        const updatedErrors = {
          ...validationErrors,
          [`numberOfUnits${index}`]: null
        };
        setValidationErrors(updatedErrors);
      } else {
        values[index].NmbOfUnits = '';
      }
    } else if (inputName === 'Pieces') {
      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      handlePushAddedCommodityInfo(inputValue, 'Pieces');
      // if (parseInt(inputValue, 10) >= 0) {
      //   values[index].NmbOfUnits = inputValue;
      // }
      if (!isNaN(inputValue) && parseFloat(inputValue) > 0) {
        values[index].Pieces = inputValue;
        const updatedErrors = {
          ...validationErrors,
          [`numberOfPieces${index}`]: null
        };
        setValidationErrors(updatedErrors);
      } else {
        values[index].Pieces = '';
      }
    } else if (inputName === 'UnitType') {
      if (event !== null) {
        filteredUnitType =
          shipTypeValue === 'LTL'
            ? LTLUnitTypeArr.filter(option =>
                option.toLowerCase().includes(event?.toLowerCase())
              )
            : ParcelUnitTypeArr.filter(option =>
                option.toLowerCase().includes(event?.toLowerCase())
              );
      }
      setUnitTypeHoveredValue(filteredUnitType[0]);
      // setUnitTypeName('');
      // values[index].UnitTypeValue = event;
      if (!values[index]) {
        // If values[index] is undefined, create a new object
        values[index] = {};
      }

      setUnitTypeName('');
      values[index].UnitTypeValue = event;
      handlePushAddedCommodityInfo(event, 'UnitType');
    } else if (inputName === 'Stackable') {
      if (type === 'TLCase') {
        values[index].StackAble = event.target.value === 'Yes' ? true : false;
        handlePushAddedCommodityInfo(event, 'Stackable');
      } else {
        values[index].StackAble = event;
        handlePushAddedCommodityInfo(event, 'Stackable');
      }
    } else if (inputName === 'Length') {
      PersistedPaymentType = undefined;
      const inputValue = event.target.value.replace(/[^0-9]/g, '');

      values[index].Length = inputValue;
      handlePushAddedCommodityInfo(inputValue, 'Length');

      const updatedErrors = {
        ...validationErrors,
        PlengthError: null
      };
      setValidationErrors(updatedErrors);
    } else if (inputName === 'Width') {
      PersistedPaymentType = undefined;

      const inputValue = event.target.value.replace(/[^0-9]/g, '');

      handlePushAddedCommodityInfo(inputValue, 'Width');

      values[index].Width = inputValue;
      const updatedErrors = {
        ...validationErrors,
        PwidthError: null
      };
      setValidationErrors(updatedErrors);
    } else if (inputName === 'itemText') {
      const inputValue = event.target.value;

      handlePushAddedCommodityInfo(inputValue, 'itemText');

      values[index].itemText = inputValue;
    } else if (inputName === 'Vehicle') {
      handlePushAddedCommodityInfo(event.target.value, 'Width');

      values[index].Vehicle = event.target.value;
      const updatedErrors = {
        ...validationErrors,
        VehicleError: null
      };
      setValidationErrors(updatedErrors);
    } else {
      PersistedPaymentType = undefined;

      const inputValue = event.target.value.replace(/[^0-9]/g, '');
      handlePushAddedCommodityInfo(inputValue, 'Height');

      values[index].Height = inputValue;
      const updatedErrors = {
        ...validationErrors,
        PheightError: null
      };
      setValidationErrors(updatedErrors);
    }

    const length = parseFloat(values[index].Length);
    const width = parseFloat(values[index].Width);
    const height = parseFloat(values[index].Height);
    const weight = parseFloat(values[index].WeightLBS);
    const pieces = parseInt(values[index].NmbOfUnits);
    if (
      inputName !== 'Class' &&
      (values[index].Length == '' ||
        values[index].Width == '' ||
        values[index].Height == '')
    ) {
      values[index].Class = '50';
    }
    if (
      !isNaN(length) &&
      length > 0 &&
      !isNaN(width) &&
      width > 0 &&
      !isNaN(height) &&
      height > 0 &&
      !isNaN(weight) &&
      weight > 0 &&
      !isNaN(pieces) &&
      pieces > 0
    ) {
      // const volumePerPiece = (length * width * height * pieces) / 1728;
      const totalVolume = (length * width * height * pieces) / 1728;
      const totalWeight = weight;

      const density = totalWeight / totalVolume;
      const freightClass = getFreightClassFromDensity(density);

      values[index].TotalVolume = parseFloat(totalVolume.toFixed(2));
      values[index].density = parseFloat(density.toFixed(2));
      values[index].estimatedFreightClass = freightClass;
      if (values[index].Class !== event && PersistedPaymentType === undefined) {
        values[index].Class = freightClass;
      }
    } else {
      values[index].TotalVolume = null;
      values[index].density = null;
      values[index].estimatedFreightClass = null;
    }
    setNewAddedDimensionsRow(values);
  };

  const handlePushAddedCommodityInfo = (removedIndex, valueName) => {
    let CommodityInfoApi = [];
    if (valueName === 'totalWeightMinus') {
      const updatedRows = finalCommodityInfoApi.filter(
        (row, index) => index !== removedIndex
      );
      setFinalCommodityInfoApi(updatedRows);
    } else {
      for (let i = 0; i < newAddedDimensionsRow.length; i++) {
        CommodityInfoApi.push({
          freightClass:
            shipTypeValue === 'Parcel' ? '' : newAddedDimensionsRow[i].Class,
          packaging: newAddedDimensionsRow[i].UnitTypeValue,
          units: newAddedDimensionsRow[i].NmbOfUnits,
          pieces: newAddedDimensionsRow[i].Pieces,
          weight: {
            units: 'lbs',
            value: newAddedDimensionsRow[i].WeightLBS
              ? newAddedDimensionsRow[i].WeightLBS
              : 0
            // valueName === 'totalWeight' ? totalWeight : totalDimensionsWeightSum
          },
          nmfc: newAddedClassRow[0].NMFCnumber,
          dimensions: {
            length: newAddedDimensionsRow[i].Length
              ? newAddedDimensionsRow[i].Length
              : // : shipTypeValue === 'Parcel'
                //   ? 15
                0,
            width: newAddedDimensionsRow[i].Width
              ? newAddedDimensionsRow[i].Width
              : // : shipTypeValue === 'Parcel'
                //   ? 11
                0,
            height: newAddedDimensionsRow[i].Height
              ? newAddedDimensionsRow[i].Height
              : // : shipTypeValue === 'Parcel'
                //   ? 14
                0,
            dimensionsUom: 'inches'
          },
          isStackable: newAddedDimensionsRow[i].StackAble,
          itemText: newAddedDimensionsRow[i].itemText
        });
      }
      // let CommodityInfoApi = [
      //   {
      // freightClass: newAddedDimensionsRow[0].Class,
      // packaging: newAddedDimensionsRow[0].UnitTypeValue,
      // pieces: newAddedDimensionsRow[0].NmbOfUnits,
      // weight: {
      //   units: 'lbs',
      //   value: TotalWeightSum
      // },
      // nmfc: newAddedClassRow[0].NMFCnumber,
      // dimensions: {
      //   length: newAddedDimensionsRow[0].Length,
      //   width: newAddedDimensionsRow[0].Width,
      //   height: newAddedDimensionsRow[0].Height,
      //   dimensionsUom: 'inches',
      //   isStackable: newAddedDimensionsRow[0].StackAble
      // }
      //   }
      // ];
      setFinalCommodityInfoApi(CommodityInfoApi);
      return CommodityInfoApi;
    }
  };

  const handleAddMultiPickups = (e, pickupIndex) => {
    setMultiPickupRows(prev => {
      const updated = [...prev];

      if (pickupIndex >= 0 && pickupIndex < updated.length) {
        updated[pickupIndex] = {
          ...updated[pickupIndex],
          pickupLineItems: [
            ...(updated[pickupIndex].pickupLineItems || []),
            {
              Class: '50',
              WeightLBS: '',
              UnitTypeValue: 'Pallet',
              NmbOfUnits: '1',
              Pieces: '1',
              StackAble: false,
              Length: 0,
              Width: 0,
              Height: 0
            }
          ]
        };
      }

      return updated;
    });
  };

  const handleRemoveMultiPickupLineItem = (pickupIndex, itemIndex) => {
    setTLValidationErrors([]);
    setMultiPickupRows(prev => {
      const updated = [...prev];

      if (
        pickupIndex >= 0 &&
        pickupIndex < updated.length &&
        itemIndex >= 0 &&
        itemIndex < (updated[pickupIndex].pickupLineItems?.length || 0)
      ) {
        const updatedLineItems = [...updated[pickupIndex].pickupLineItems];
        updatedLineItems.splice(itemIndex, 1); // remove the item

        updated[pickupIndex] = {
          ...updated[pickupIndex],
          pickupLineItems: updatedLineItems
        };
      }

      return updated;
    });
  };

  const handleAddNewRow = e => {
    const temp = [];
    if (e === 'class') {
      const values = [...newAddedClassRow];
      values.push({ WeightLBS: '', Class: ClassArray[0], NMFCnumber: '' });
      setNewAddedClassRow(values);
    } else {
      const values = [...newAddedDimensionsRow];
      values.push({
        Class: '50',
        WeightLBS: '',
        UnitTypeValue:
          shipTypeValue === 'LTL'
            ? LTLUnitTypeArr[0]
            : newAddedDimensionsRow[0]?.UnitTypeValue,
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: shipTypeValue === 'Parcel' ? '15' : 0,
        Width: shipTypeValue === 'Parcel' ? '11' : 0,
        Height: shipTypeValue === 'Parcel' ? '14' : 0
      });
      setNewAddedDimensionsRow(values);
    }
  };

  const parseNumberFromString = str => {
    return Number(str.replace(/,/g, ''));
  };
  const handleSubtractNewRow = (e, removedIndex) => {
    if (e === 'class') {
      const values = [...newAddedClassRow];
      values.splice(removedIndex, 1);
      // finalCommodityInfoApi.splice(removedIndex, 1);
      setNewAddedClassRow(values);
      let totalWeightLBS = parseInt(newAddedClassRow[removedIndex].WeightLBS);
      let totalGWeight = parseInt(newAddedClassRow[removedIndex].GrossWeight);
      let minus;
      let grossMinus;
      if (isNaN(totalWeightLBS) || isNaN(totalGWeight)) {
        minus = parseInt(totalDimensionsWeightSum) - 0;
        grossMinus = parseInt(totalGrossWeight) - 0;
      } else {
        minus = parseInt(totalDimensionsWeightSum) - totalWeightLBS;
        grossMinus = parseInt(totalGrossWeight) - totalGWeight;
      }
      setTotalClassWeightSum(minus);
      setTotalGrossWeight(grossMinus);
      handlePushAddedCommodityInfo(removedIndex, 'totalWeightMinus');

      // setTotalDimensionsWeightSum(totalDimensionsWeightSum - totalWeightLBS);
      let TotalWeightSum = totalDimensionsWeightSum - totalWeightLBS;
    } else {
      const values = [...newAddedDimensionsRow];
      values.splice(removedIndex, 1);
      // finalCommodityInfoApi.splice(removedIndex, 1);

      setNewAddedDimensionsRow(values);
      let totalWeightLBS = parseInt(
        newAddedDimensionsRow[removedIndex].WeightLBS
      );
      let totalGrossWeightSum = parseInt(
        newAddedDimensionsRow[removedIndex].GrossWeight
      );
      let minus;
      let minusGross;
      if (isNaN(totalWeightLBS) || isNaN(totalGrossWeightSum)) {
        minus = parseInt(totalDimensionsWeightSum) - 0;
        minusGross = parseInt(totalGrossWeight) - 0;
      } else {
        setTotalDimensionsWeightSum(
          prev => parseInt(prev) - parseInt(totalWeightLBS)
        );
        setTotalGrossWeight(
          prev => parseInt(prev) - parseInt(totalGrossWeightSum)
        );
      }
      // totalWeightLBS = totalLBSWeightDimensions - totalLBSWeightDimensions;
      // minus = totalDimensionsWeightSum - totalWeightLBS;
      setTotalDimensionsWeightSum(
        prev => parseInt(prev) - parseInt(totalWeightLBS)
      );
      setTotalGrossWeight(
        prev => parseInt(prev) - parseInt(totalGrossWeightSum)
      );
      handlePushAddedCommodityInfo(removedIndex, 'totalWeightMinus');

      setTotalLBSWeightDimensions(totalWeightLBS);
    }
  };
  const totalNetWeightLBS = useMemo(() => {
    return multiPickupRows.reduce((dropAcc, drop) => {
      const rowTotal = drop.pickupLineItems.reduce((itemAcc, item) => {
        const weight = parseFloat(item.WeightLBS) || 0;
        return itemAcc + weight;
      }, 0);
      return dropAcc + rowTotal;
    }, 0);
  }, [multiPickupRows]);

  const totalGrossWeightLBS = useMemo(() => {
    return multiPickupRows.reduce((dropAcc, drop) => {
      const rowTotal = drop.pickupLineItems.reduce((itemAcc, item) => {
        const weight = parseFloat(item.GrossWeight) || 0;
        return itemAcc + weight;
      }, 0);
      return dropAcc + rowTotal;
    }, 0);
  }, [multiPickupRows]);

  const totalDeliveryGrossWeightLBS = useMemo(() => {
    return multiDropsRows.reduce((dropAcc, drop) => {
      const rowTotal = drop.deliveryLineItems.reduce((itemAcc, item) => {
        const weight = parseFloat(item.GrossWeight) || 0;
        return itemAcc + weight;
      }, 0);
      return dropAcc + rowTotal;
    }, 0);
  }, [multiDropsRows]);

  useEffect(() => {
    setTotalDeliveryGrossWeight(totalDeliveryGrossWeightLBS);
  }, [totalDeliveryGrossWeightLBS]);

  useEffect(() => {
    setTotalDimensionsWeightSum(totalGrossWeightLBS);
  }, [totalGrossWeightLBS]);

  const handleClearMultiItemErrors = (type, pickupIndex, itemIndex, field) => {
    // if (type === 'dropRows') {
    // const pickupErrors = validateMultiPickupRows(multiPickupRows);

    // const hasPickupErrors = pickupErrors.some(
    //   rowErr => rowErr && Object.keys(rowErr).length > 0
    // );

    // if (hasPickupErrors) {
    //   console.log('âŒ Pickup validation failed:', pickupErrors);
    //   setTLValidationErrors({
    //     pickupRows: pickupErrors,
    //     dropRows: [] // clear any previous drop errors
    //   });
    // }
    // }
    // else if (type === 'pickupRows') {
    // âœ… Now validate drops only if pickups passed
    // const dropErrors =  validateMultiDropRows(multiDropsRows, TLPickupMode);

    // const hasDropErrors = dropErrors.some(
    //   rowErr => rowErr && Object.keys(rowErr).length > 0
    // );

    // if (hasDropErrors) {
    setGrossWeightError('');
    setShowWeightError(false);
    setTLValidationErrors({
      pickupRows: [], // no pickup errors
      dropRows: []
    });
    // }
  };

  useEffect(() => {
    const totalUnitsForNewType = multiPickupRows
      .flatMap(row => row.pickupLineItems)
      // .filter(item => item.UnitTypeValue === newUnitType)
      .reduce((acc, item) => acc + Number(item.NmbOfUnits || 0), 0);

    setTotalNmbofUnits(totalUnitsForNewType);
  }, [multiPickupRows]);

  const handleMultiLineItemChange = (
    type,
    pickupIndex,
    itemIndex,
    field,
    value
  ) => {
    setMultiPickupRows(prev => {
      const updated = [...prev];
      const updatedLineItems = [...updated[pickupIndex]?.pickupLineItems];

      let newValue = value;

      if (field === 'WeightLBS' || field === 'GrossWeight') {
        const inputValue = value.replace(/[^0-9]/g, '');
        const parsed = parseFloat(inputValue);
        newValue = isNaN(parsed) ? '' : Math.max(0, parsed);
      }

      if (field === 'StackAble') {
        updatedLineItems[itemIndex] = {
          ...updatedLineItems[itemIndex],
          [field]: typeof value === 'boolean' ? value : value === 'Yes'
        };
      } else {
        updatedLineItems[itemIndex] = {
          ...updatedLineItems[itemIndex],
          [field]: newValue
        };
      }

      updated[pickupIndex] = {
        ...updated[pickupIndex],
        pickupLineItems: updatedLineItems
      };

      return updated;
    });
  };
  useEffect(() => {
    handleCheckAddedRow();
  }, [newAddedClassRow]);

  const switchStyle = {
    borderRadius: 2,
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#d81b60'
    },
    '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
      backgroundColor: '#d81b60'
    },
    '&:hover .MuiSwitch-switchBase': {
      // color: 'brown'
    }
  };

  function sleep(delay = 0) {
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  const [shipFromFinalAddress, setShipFromFinalAddress] = useState(''); // eslint-disable-line no-unused-vars
  const [shipFromFinalValue, setShipFromFinalValue] = useState(ShipFrom); // eslint-disable-line no-unused-vars
  const [shipToFinalValue, setShipToFinalValue] = useState(ShipTo); // eslint-disable-line no-unused-vars
  const [shipToFinalAddress, setShipToFinalAddress] = useState(''); // eslint-disable-line no-unused-vars

  // Unified address state for both LTL and TL (Google Places)
  // { streetLines, city, state, zip, country }
  const [originDetails, setOriginDetails] = useState(
    SelectedRates?.shipFrom?.city
      ? {
          city: SelectedRates.shipFrom.city,
          state: SelectedRates.shipFrom.stateOrProvinceCode,
          zip: SelectedRates.shipFrom.postalCode,
          country: SelectedRates.shipFrom.countryCode,
          streetLines: SelectedRates.shipFrom.streetLines || '',
          company: ''
        }
      : quickQuoteTLRates?.originCity
        ? {
            city: quickQuoteTLRates.originCity,
            state: quickQuoteTLRates.originState,
            zip: quickQuoteTLRates.originZip,
            country: quickQuoteTLRates.originCountry,
            streetLines: quickQuoteTLRates.originAddress || '',
            company: quickQuoteTLRates.originCompany || ''
          }
        : null
  );
  const [destinationDetails, setDestinationDetails] = useState(
    SelectedRates?.shipTo?.city
      ? {
          city: SelectedRates.shipTo.city,
          state: SelectedRates.shipTo.stateOrProvinceCode,
          zip: SelectedRates.shipTo.postalCode,
          country: SelectedRates.shipTo.countryCode,
          streetLines: SelectedRates.shipTo.streetLines || '',
          company: ''
        }
      : quickQuoteTLRates?.destinationCity
        ? {
            city: quickQuoteTLRates.destinationCity,
            state: quickQuoteTLRates.destinationState,
            zip: quickQuoteTLRates.destinationZip,
            country: quickQuoteTLRates.destinationCountry,
            streetLines: quickQuoteTLRates.destinationAddress || '',
            company: quickQuoteTLRates.destinationCompany || ''
          }
        : null
  );

  // Contact info state for both LTL and TL
  const [originContactName, setOriginContactName] = useState(
    SelectedRates?.originContactName || ''
  );
  const [originContactEmail, setOriginContactEmail] = useState(
    SelectedRates?.originContactEmail || ''
  );
  const [originContactPhone, setOriginContactPhone] = useState(
    SelectedRates?.originContactPhone || ''
  );
  const [destinationContactName, setDestinationContactName] = useState(
    SelectedRates?.destinationContactName || ''
  );
  const [destinationContactEmail, setDestinationContactEmail] = useState(
    SelectedRates?.destinationContactEmail || ''
  );
  const [destinationContactPhone, setDestinationContactPhone] = useState(
    SelectedRates?.destinationContactPhone || ''
  );

  // const history = useHistory()
  const spinnerStyles = {
    '-webkit-appearance': 'none',
    backgroundColor: '#000', // Set the background color
    background:
      '#000 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAcCAYAAADr9QYhAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAI6ADAAQAAAABAAAAHAAAAACbzWzwAAABB0lEQVRIDe2XMQ6DMAxFf6suwAjszLDCTeASHALEyFlg5hLsXIJDtPIQVFkkgrhDVCWLcQzJ84/liEeSJG84MIqiwMMVmCAI8HRAlAPBwxxSsIf/VKZpGozjiCiKWL7X3Z8oQyB1XSPLMnRdZw0khlEgKn8JkAiGg0iBrJse1UZZlmr/U7vvO7ZtO43xSWp61jB8ManvO7BJQVEBmxa2iXkYnWpOKfPSUV6Zb9sWaZpqX12WBeu6auM8IOozBNL3/SnQNE2Y55nvp/XFfYY67DAMIPs97oKob8U1w4FsQQhIdEwqI7J0ZFVVgerEZvi7yaSauGZMi9+NOQMThqEbP3FxHCPPc3wAmdpEetL9b2QAAAAASUVORK5CYII=) no-repeat center center',
    filter: 'invert(100%)', // Invert the spinner color to white
    width: '1.7em',
    opacity: 1,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    borderTopRightRadius: '0.25rem',
    borderBottomRightRadius: '0.25rem'
  };

  const onShipFromChange = (event, values, pickupIndex) => {
    if (values) {
      setShipFromloading(true);
      const reqId = ++shipFromReqId.current;
      GetLocationsJSON(values)
        .then(res => {
          if (reqId !== shipFromReqId.current) return;
          res.status === 200 && handleUSAddresses(res.data, 'shipFrom', values);
        })
        .catch(err => {
          if (reqId !== shipFromReqId.current) return;
          setShipFromloading(false);
        });
    } else {
      setShipFromloading(false);
    }
    let FinalObj = {};
    if (values) {
      const updatedErrors = { ...validationErrors, shipFromErr: null };
      setValidationErrors(updatedErrors);
      setShipFromFinalValue(values);

      const tempData = parseAddress(values);
      const City = tempData.city;
      const State = tempData.state;
      const ZipCode = tempData.zip;
      const CountryCode = tempData.countryCode;

      FinalObj = {
        City,
        State,
        ZipCode,
        CountryCode
      };

      setShipFromFinalAddress(FinalObj);

      if (pickupIndex) {
        setMultiPickupRows(prev =>
          prev.map((row, i) =>
            i === pickupIndex
              ? {
                  ...row,
                  pickupAddress: values
                }
              : row
          )
        );
        handleClearRowValidationError(
          'pickupRows',
          pickupIndex,
          'pickupAddress'
        );
      }
    } else {
      // setShipFromFinalAddress('');
      // setShipFromFinalValue('');
      // setShipToFinalValue('');
    }
  };

  const onShipToChange = (event, values, dropIndex) => {
    setResult([]);
    // var filtered = [];
    if (values) {
      setShipToloading(true);
      const formattedCode = values.replace(/\s/g, '');

      const reqId = ++shipToReqId.current;
      GetLocationsJSON(values)
        .then(res => {
          if (reqId !== shipToReqId.current) return;
          res.status === 200 && handleUSAddresses(res.data, 'shipTo', values);
        })
        .catch(err => {
          if (reqId !== shipToReqId.current) return;
          setShipToloading(false);
          console.log(err, 'Get Locations Error');
        });
      // filtered = shipCity.filter(option =>
      //   option?.toLowerCase().includes(values?.toLowerCase())
      // );
    } else {
      setShipToloading(false);
    }
    // setShipToHoveredValue(filtered[0]);
    let FinalObj2 = {};
    if (values) {
      const updatedErrors = { ...validationErrors, shipToErr: null };
      setValidationErrors(updatedErrors);
      // setShipFromErr(false);
      setShipToFinalValue(values);

      if (dropIndex) {
        setMultiDropsRows(prev =>
          prev.map((row, i) =>
            i === dropIndex
              ? {
                  ...row,
                  dropAddress: values
                }
              : row
          )
        );
        handleClearRowValidationError('dropRows', dropIndex, 'dropAddress');
      }
      const tempData = parseAddress(values);

      const City = tempData.city;
      const State = tempData.state;
      const ZipCode = tempData.zip;
      const CountryCode = tempData.countryCode;

      FinalObj2 = {
        City,
        State,
        ZipCode,
        CountryCode
      };

      setShipToFinalAddress(FinalObj2);
    } else {
      // setShipToFinalAddress('');
      // setShipToFinalValue('');
      // setShipFromErr(true);
    }
  };
  const filterOptions = createFilterOptions({
    limit: 1000
  });

  const validateAutocompletes = (obj, deepClone) => {
    const errors = {};
    if (!shipTypeValue) {
      errors['shipTypeErr'] = 'Please select ship type';
      selectShipType.current.focus();
    }
    //  else if (!paymentTypeValue) {
    //   errors['paymentTypeErr'] = 'Please select payment type';
    // }
    else if (
      !shipLocationValue &&
      paymentTypeValue !== 'Third Party'
      //  && shipTypeValue !== 'TL'
    ) {
      errors['shipTypeLocation'] = 'Please select ship location';
      // if (selectLocations.current) {
      selectLocations.current.focus();
      // }
    } else if (
      !originDetails?.city &&
      paymentTypeValue !== 'Outbound Prepaid'
    ) {
      errors['shipFromErr'] = 'Please select pickup location';
    } else if (
      paymentTypeValue !== 'Outbound Prepaid' &&
      (!originDetails?.city ||
        !originDetails?.state ||
        !originDetails?.zip ||
        !originDetails?.country)
    ) {
      errors['shipFromErr'] =
        'Please select a complete pickup address (city, state, zip, country)';
    } else if (
      !destinationDetails?.city &&
      paymentTypeValue !== 'Inbound Collect'
    ) {
      errors['shipToErr'] = 'Please select delivery location';
    } else if (
      paymentTypeValue !== 'Inbound Collect' &&
      (!destinationDetails?.city ||
        !destinationDetails?.state ||
        !destinationDetails?.zip ||
        !destinationDetails?.country)
    ) {
      errors['shipToErr'] =
        'Please select a complete delivery address (city, state, zip, country)';
    }

    if (Object.keys(errors).length) {
      setValidationErrors(errors);
      return;
    }
    if (shipTypeValue !== 'TL') {
      newAddedDimensionsRow.forEach((dimension, index) => {
        if (!dimension.WeightLBS) {
          errors[`weightEr${index}`] = 'Weight is required';
          enterWeight?.current?.focus();
        }
        if (!dimension.NmbOfUnits) {
          errors[`numberOfUnits${index}`] = '# of units required';
        }
        if (!dimension.Pieces) {
          errors[`numberOfPieces${index}`] = '# of pieces required';
        }
      });
    }

    if (shipTypeValue !== 'TL') {
      newAddedDimensionsRow.forEach((dimension, index) => {
        if (!dimension.WeightLBS) {
          errors[`weightEr${index}`] = 'Weight is required';
          enterWeight?.current?.focus();
        }
        if (!dimension.NmbOfUnits) {
          errors[`numberOfUnits${index}`] = '# of units required';
        }
        if (!dimension.Pieces) {
          errors[`numberOfPieces${index}`] = '# of pieces required';
        }
      });
    }

    // else if (shipTypeValue === 'Parcel' && !newAddedDimensionsRow[0].Length) {
    //   errors['PlengthError'] = 'enter length';
    // } else if (shipTypeValue === 'Parcel' && !newAddedDimensionsRow[0].Width) {
    //   errors['PwidthError'] = 'enter width';
    // } else if (shipTypeValue === 'Parcel' && !newAddedDimensionsRow[0].Height) {
    //   errors['PheightError'] = 'enter height';
    // }

    // if (ShipFrom) {
    //   const updatedErrors = { ...validationErrors, shipToErr: null };
    //   setValidationErrors(updatedErrors);
    // }
    setValidationErrors(errors);

    if (Object.keys(errors).length) {
      return;
    }
    if (shipTypeValue === 'TL') {
      if (isReefer && temperature === '') {
        setTempError('Enter temperature ');
      } else {
        const secondObject = {
          shipmentType: 'TL',
          locationFull: obj.locationName,
          location: obj.location,
          paymentType:
            paymentTypeValue === 'Outbound Prepaid'
              ? '0'
              : paymentTypeValue === 'Inbound Collect'
                ? '1'
                : '2',
          shipFrom: {
            city: obj.originCity,
            stateOrProvinceCode: obj.originState,
            postalCode: obj.originZip,
            countryCode: obj.originCountry,
            residential: false,
            streetLines: obj.originAddress
          },
          shipTo: {
            city: obj.destinationCity,
            stateOrProvinceCode: obj.destinationState,
            postalCode: obj.destinationZip,
            countryCode: obj.destinationCountry,
            residential: false, // Assuming residential is false by default
            streetLines: obj.destinationAddress
          },
          shipmentDate: obj.orderDate,
          deliveryDate: obj.deliveryDate,
          totalGrossWeight: totalGrossWeight,
          isHazmat: obj.isHazmat,
          commodityInfo: {
            freightClass: '',
            packaging: '',
            units: '',
            pieces: '',
            weight: {
              units: 'lbs', // Assuming weight units are pounds
              value: ''
            },
            nmfc: '',
            dimensions: {
              length: '',
              width: '',
              height: '',
              dimensionsUom: 'inches', // Assuming dimensions are in inches
              isStackable: false
            }
          },
          pickupOptions: {
            ...obj.pickupOptions,
            callBeforeDelivery: obj.pickupOptions.callBeforeDelivery || false
          },
          deliveryOptions: {
            ...obj.deliveryOptions,
            callBeforeDelivery: obj.deliveryOptions.callBeforeDelivery || false
          },
          codAmount: CODAmount ? parseInt(CODAmount) : 0,
          declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
          agencyId: 198, // Assuming agency ID is 198
          isGuaranteed: false, // Default value
          locationId: obj.locationId
        };

        const CopyNewAddedClassRow = [...newAddedClassRow];

        dispatch(setQuickQuoteRateValues(secondObject));
        dispatch(setQuickQuoteTLRateValues(obj));

        dispatch(setQuickQuoteRateLoc(selectedLocation));

        dispatch(setQuickQuotePickUpCheckedRedux(pickUpChecked));
        dispatch(setQuickQuoteDeliveryCheckedRedux(deliveryChecked));
        dispatch(setClassDimensionsButton(alignment));
        dispatch(setClassRows(newAddedClassRow));
        dispatch(setDimensionRows(newAddedDimensionsRow));
        dispatch(setClassWeight(totalGrossWeight));
        dispatch(setDimensionsWeight(totalDimensionsWeightSum));
        history.push({
          pathname: '/bookshipmentTL',
          state: {
            createshipObj: obj,
            pickupRowData: JSON.stringify(obj),
            disptachOpen: 'Get Quote',
            rateType: 'Quick Quote',
            carrierApiNames: ParcelCarrierApiNames,
            paymentType: obj.paymentType,
            locationId: shipLocationID,
            userLocationsArr: userLocationsArr
          }
        });
      }
    }
    if (
      shipTypeValue !== 'TL' &&
      shipTypeValue &&
      paymentTypeValue &&
      (originDetails || paymentTypeValue === 'Outbound Prepaid') &&
      (destinationDetails || paymentTypeValue === 'Inbound Collect')
    ) {
      const CopyNewAddedClassRow = [...newAddedClassRow];
      dispatch(setQuickQuoteTLRateValues({}));

      dispatch(setQuickQuoteRateValues(obj));

      dispatch(setQuickQuoteRateLoc(selectedLocation));

      dispatch(setQuickQuotePickUpCheckedRedux(pickUpChecked));
      dispatch(setQuickQuoteDeliveryCheckedRedux(deliveryChecked));
      dispatch(setClassDimensionsButton(alignment));
      dispatch(setClassRows(newAddedClassRow));
      dispatch(setDimensionRows(newAddedDimensionsRow));
      // dispatch(setClassWeight(totalClassWeightSum));
      dispatch(setDimensionsWeight(totalDimensionsWeightSum));
      history.push({
        pathname: '/bookshipment',
        state: {
          pickupRowData: JSON.stringify(obj),
          disptachOpen: 'Get Quote',
          rateType: 'Quick Quote',
          paymentType: obj.paymentType,
          locationId: shipLocationID,
          userLocationsArr: userLocationsArr,
          shipmentMiles: calDistanceValue,
          origin: ''
        }
      });
    }
  };

  const handleChangePaymentType = (event, newValue) => {
    setOpenShipFrom(false);
    setOpenShipTo(false);
    var filtered = [];
    if (!Array.isArray(newValue) && newValue !== null) {
      filtered =
        shipTypeValue === 'LTL'
          ? LTLPaymentTypeArr.filter(option =>
              option.toLowerCase().includes(newValue?.toLowerCase())
            )
          : parcelPaymentTypeArr.filter(option =>
              option.toLowerCase().includes(newValue?.toLowerCase())
            );
    }
    setPaymentTypeHoveredValue(filtered[0]);
    if (newValue === null) {
      setPaymentTypeValue(LTLPaymentTypeArr[0]);
    }
    if (newValue === 'Third Party') {
      setPaymentTypeInputChange(true);
      setShipFromFinalAddress('');
      setShipToFinalAddress('');
      setShipFromFinalValue('');
      setShipToFinalValue('');
      setOriginDetails(null);
      setDestinationDetails(null);
      setPaymentTypeValue(newValue);
    } else if (newValue === 'Outbound Prepaid') {
      const updatedErrors = { ...validationErrors, shipFromErr: null };
      setValidationErrors(updatedErrors);
      setPaymentTypeInputChange(true);
      setShipFromFinalAddress(shipLocationValue);
      setShipFromFinalValue('');
      setPaymentTypeValue(newValue);
      setShipToFinalAddress('');
      setShipToFinalValue('');
      setDestinationDetails(null);
    } else if (
      newValue === 'Inbound Collect'
      // || newValue === 'Receiver'
    ) {
      setPaymentTypeInputChange(true);
      setShipToFinalAddress(shipLocationValue);
      setShipToFinalValue('');
      setPaymentTypeValue(newValue);
      setOpenShipFrom(false);
      setShipFromFinalAddress('');
      setShipFromFinalValue('');
      setOriginDetails(null);
    }
    setMultiDropsRows([
      {
        dropAddress: '',
        itemText: '',
        expDropDeliveryDate: deliveryDate,
        deliveryOpenHours: originOpenTimeValue,
        deliveryCloseHours: originCloseTimeValue,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        deliveryLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
    setMultiPickupRows([
      {
        pickupAddress: '',
        itemText: '',
        pickupDate: shipmentDate,
        expPickDeliveryDate: '',
        pickupOpenHours: originOpenTimeValue,
        pickupCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        pickupLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: LTLUnitTypeArr?.[0] ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
  };

  const [distanceMiles, setDistanceMiles] = useState(0);
  const [calDistanceValue, setCalDistanceValue] = useState(0);

  useEffect(() => {
    const ApiZipFrom = originDetails?.zip || '';
    const ApiZipTo = destinationDetails?.zip || '';

    setDistanceMiles(0);

    if (ApiZipFrom && ApiZipTo) {
      CalculateDistance(ApiZipFrom, ApiZipTo)
        .then(res => {
          setDistanceMiles(res?.data?.rows[0]?.elements[0]?.distance?.text);
          setCalDistanceValue(res?.data?.rows[0]?.elements[0]?.distance?.value);
        })
        .catch(err => console.log(err, 'Distance Api Error'));
    }
  }, [originDetails, destinationDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePickupModeChange = event => {
    setTLPickupMode(event.target.value);
    setMultiDropsRows([
      {
        dropAddress: '',
        itemText: '',
        expDropDeliveryDate: deliveryDate,
        deliveryOpenHours: originOpenTimeValue,
        deliveryCloseHours: originCloseTimeValue,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        deliveryLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: newAddedDimensionsRow[0]?.UnitTypeValue ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
    setMultiPickupRows([
      {
        pickupAddress: '',
        itemText: '',
        pickupDate: shipmentDate,
        expPickDeliveryDate: '',
        pickupOpenHours: originOpenTimeValue,
        pickupCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        pickupLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: newAddedDimensionsRow[0]?.UnitTypeValue ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
  };

  const handleTLequipmentTypeChnage = event => {
    setTLequipmentType(event.target.value);
  };
  const handleTLDriverTypeChange = event => {
    setTLDriverType(event.target.value);
  };
  const handleShipLocationChange = (event, newValue, reason) => {
    // reason can be: 'input' | 'selectOption' | 'clear' | 'blur' | 'removeOption'
    setOpenShipFrom(false);
    setOpenShipTo(false);
    setCity('');

    // Typing in the input
    if (reason === 'input') {
      const text = (newValue ?? '').toString();
      setShipLocationValue(text);
      setLocationInputChange(true);

      // update hovered suggestion
      const filtered = shipLocation.filter(o =>
        o.location?.toLowerCase().includes(text.toLowerCase())
      );
      setLocationHoveredValue(filtered[0] || null);
      return;
    }

    // Selecting an option
    if (reason === 'selectOption') {
      if (newValue?.isButton) {
        handleAddLocation();
        return;
      }

      if (newValue?.location) {
        const parts = newValue.location.split(': ');
        const label = parts[1] || parts[0] || '';

        setShipLocationValue(label); // input text
        setShipLocationID(newValue.id); // keep id
        setSelectedLocation(newValue); // <-- selected option object
        dispatch(setQuickQuoteRateLoc(newValue));

        if (paymentTypeValue === 'Outbound Prepaid')
          setShipFromFinalAddress(label);
        if (paymentTypeValue === 'Inbound Collect')
          setShipToFinalAddress(label);

        setValidationErrors(v => ({ ...v, shipTypeLocation: null }));
        setLocationInputChange(false);
        return;
      }
    }

    // Clearing or anything else
    if (reason === 'clear') {
      setShipLocationValue('');
      setSelectedLocation(null);
      setLocationInputChange(true);
    }
  };

  const handleClearAddresses = () => {
    setDistanceMiles(0);
    setSelectedLocation('');
    setCalDistanceValue(0);
    setTotalDimensionsWeightSum('');
    setShipLocationValue('');
    setShipLocationID('');
    setShipFromFinalAddress('');
    setShipToFinalAddress('');
    setShipFromFinalValue('');
    setShipToFinalValue('');
    handleClearForm();
  };
  const handleTlFlow = () => {
    handleClearAddresses();
    setNewAddedDimensionsRow([
      {
        Class: '50',
        WeightLBS: '',
        UnitTypeValue: newAddedDimensionsRow[0]?.UnitTypeValue,
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: 0,
        Width: 0,
        Height: 0
      }
    ]);
  };
  const handleParcelFlow = () => {
    handleClearAddresses();

    setNewAddedDimensionsRow([
      {
        Class: '50',
        WeightLBS: '',
        UnitTypeValue: LTLUnitTypeArr[2],
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: '15',
        Width: '11',
        Height: '14'
      }
    ]);
  };

  const handleLTLFlow = () => {
    handleClearAddresses();

    setNewAddedDimensionsRow([
      {
        Class: '50',
        WeightLBS: '',
        UnitTypeValue: LTLUnitTypeArr[0],
        NmbOfUnits: '1',
        Pieces: '1',
        StackAble: false,
        Length: '',
        Width: '',
        Height: ''
      }
    ]);
  };

  const isMobile = useIsMobile();
  const responsiveStyle = {
    height: '33vw',
    overflowY: 'hidden',
    position: 'relative'
  };

  const largeScreenStyle = {
    height: '27vw',
    overflowY: 'hidden',
    position: 'relative'
  };
  const validateMultiPickupRows = rows => {
    const errors = [];

    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const row = rows[rowIndex];
      const rowErrors = {};
      console.log(row, 'rowvalidation');
      if (!row.pickupAddress) {
        rowErrors.pickupAddress = 'Pickup address is required';
        errors[rowIndex] = rowErrors;
        selectShipFrom?.current[rowIndex]?.focus();
        break;
      }

      if (!row.expPickDeliveryDate) {
        handleIconClick(rowIndex);
        rowErrors.expPickDeliveryDate = 'Select Exp delivery date';
        errors[rowIndex] = rowErrors;
        break;
      }

      const lineItems = row.pickupLineItems || [];
      console.log(lineItems, 'lineItems');
      for (let itemIndex = 0; itemIndex < lineItems.length; itemIndex++) {
        const item = lineItems[itemIndex];

        if (!item.WeightLBS || parseFloat(item.WeightLBS) <= 0) {
          console.log(weightRefs.current, 'weightRefs');
          weightRefs.current?.[rowIndex]?.[itemIndex]?.focus();
          rowErrors.pickupLineItems = {
            [itemIndex]: { WeightLBS: 'Enter Net Weight' }
          };
          errors[rowIndex] = rowErrors;
          return errors;
        } else if (!item.GrossWeight || parseFloat(item.GrossWeight) <= 0) {
          grossWeightRefs.current?.[rowIndex]?.[itemIndex]?.focus();
          rowErrors.pickupLineItems = {
            [itemIndex]: { GrossWeight: 'Enter Gross Weight' }
          };
          errors[rowIndex] = rowErrors;
          return errors;
        } else if (parseFloat(item.GrossWeight) < parseFloat(item.WeightLBS)) {
          grossWeightRefs.current?.[rowIndex]?.[itemIndex]?.focus();
          rowErrors.pickupLineItems = {
            [itemIndex]: {
              GrossWeight: 'Gross Weight Cannot be less than Net Weight'
            }
          };
          errors[rowIndex] = rowErrors;
          return errors;
        }
      }
    }

    return errors;
  };

  const datepickerRef = useRef([]);
  const deliveryDatepickerRef = useRef(null);
  const pickupDatepickerRef = useRef(null);

  const handlePickupDateIconClick = () => {
    if (pickupDatepickerRef.current) {
      pickupDatepickerRef.current.setFocus();

      if (pickupDatepickerRef.current.input) {
        pickupDatepickerRef.current.input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  const handleDeliveryDateIconClick = () => {
    if (deliveryDatepickerRef.current) {
      deliveryDatepickerRef.current.setFocus();

      if (deliveryDatepickerRef.current.input) {
        deliveryDatepickerRef.current.input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };

  const handleIconClick = rowIndex => {
    console.log(datepickerRef, rowIndex, 'datepickerRef');
    if (datepickerRef.current) {
      datepickerRef?.current[rowIndex].setFocus();

      if (datepickerRef.current[rowIndex].input) {
        datepickerRef.current[rowIndex].input.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  const validateMultiDropRows = rows => {
    console.log(rows, 'rowsvalidation');
    const errors = [];
    const skipDropValidation = TLPickupMode.includes('1 Drop');

    const buildUnitTotals = (rows, key) => {
      return rows.reduce((acc, row) => {
        (row[key] || []).forEach(item => {
          const type = (item.UnitTypeValue || '').trim();
          const qty = parseFloat(item.NmbOfUnits) || 0;
          if (type) acc[type] = (acc[type] || 0) + qty;
        });
        return acc;
      }, {});
    };

    const pickupUnits = buildUnitTotals(
      multiPickupRows || [],
      'pickupLineItems'
    );
    const deliveryUnits = buildUnitTotals(rows || [], 'deliveryLineItems');

    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const row = rows[rowIndex];
      const rowErrors = {};

      if (!row.dropAddress?.trim()) {
        rowErrors.dropAddress = 'Delivery address is required';
        errors[rowIndex] = rowErrors;
        selectShipTo?.current?.[rowIndex]?.focus?.();
        break;
      }

      if (!skipDropValidation) {
        const lineItems = row.deliveryLineItems || [];

        for (let itemIndex = 0; itemIndex < lineItems.length; itemIndex++) {
          const item = lineItems[itemIndex];

          if (!item.GrossWeight || parseFloat(item.GrossWeight) <= 0) {
            rowErrors.deliveryLineItems = {
              [itemIndex]: { GrossWeight: 'Enter Gross Weight' }
            };
            errors[rowIndex] = rowErrors;
            grossWeightRefsDelivery?.current?.[rowIndex]?.[
              itemIndex
            ]?.focus?.();
            break;
          }

          const totalGrossWeightOfRow = row.deliveryLineItems.reduce(
            (sum, i) => {
              const weight =
                parseFloat(
                  i.GrossWeight?.toString().replace(/,/g, '').trim()
                ) || 0;
              return sum + weight;
            },
            0
          );

          // --- Missing weight check ---
          if (
            totalDeliveryGrossWeight < totalGrossWeightLBS &&
            totalGrossWeightLBS - totalDeliveryGrossWeight !== 0
          ) {
            const remaining = totalGrossWeightLBS - totalDeliveryGrossWeight;

            // Calculate missing weight per unit type
            const totalPickupQty = Object.values(pickupUnits).reduce(
              (a, b) => a + b,
              0
            );
            const avgWeightPerUnit =
              totalPickupQty > 0
                ? totalGrossWeightLBS / totalPickupQty
                : totalGrossWeightLBS;

            const missingWeightDetails = Object.keys(pickupUnits)
              .map(type => {
                const pickupQty = pickupUnits[type] || 0;
                const deliveryQty = deliveryUnits[type] || 0;
                if (pickupQty > deliveryQty) {
                  const diffQty = pickupQty - deliveryQty;
                  const missingWeight = Math.round(diffQty * avgWeightPerUnit);
                  return `<b>${missingWeight} lbs</b> missing in <b>${type}</b>`;
                }
                return null;
              })
              .filter(Boolean)
              .join(', ');

            rowErrors.deliveryLineItems = { [itemIndex]: { GrossWeight: '' } };
            errors[rowIndex] = rowErrors;

            setGrossWeightError(
              `Some items are missing weight, around <b>${remaining} lbs</b> total. </br> Details: ${
                missingWeightDetails || 'N/A'
              }.`
            );
            setShowWeightError(true);
            grossWeightRefsDelivery?.current?.[rowIndex]?.[
              itemIndex
            ]?.focus?.();
            break;
          }

          // --- Extra weight check ---
          if (
            totalDeliveryGrossWeight > totalGrossWeightLBS &&
            totalGrossWeightLBS - totalDeliveryGrossWeight !== 0
          ) {
            const extra = totalDeliveryGrossWeight - totalGrossWeightLBS;

            // Calculate extra weight per unit type
            const totalPickupQty = Object.values(pickupUnits).reduce(
              (a, b) => a + b,
              0
            );
            const avgWeightPerUnit =
              totalPickupQty > 0
                ? totalGrossWeightLBS / totalPickupQty
                : totalGrossWeightLBS;

            const extraWeightDetails = Object.keys(deliveryUnits)
              .map(type => {
                const pickupQty = pickupUnits[type] || 0;
                const deliveryQty = deliveryUnits[type] || 0;
                if (deliveryQty > pickupQty) {
                  const diffQty = deliveryQty - pickupQty;
                  const extraWeight = Math.round(diffQty * avgWeightPerUnit);
                  return `<b>${extraWeight} lbs</b> extra in <b>${type}</b>`;
                }
                return null;
              })
              .filter(Boolean)
              .join(', ');

            rowErrors.deliveryLineItems = { [itemIndex]: { GrossWeight: '' } };
            errors[rowIndex] = rowErrors;

            setGrossWeightError(
              `Some items have extra weight, around <b>${extra} lbs</b> total. </br> Details: ${
                extraWeightDetails || 'N/A'
              }.`
            );
            setShowWeightError(true);
            grossWeightRefsDelivery?.current?.[rowIndex]?.[
              itemIndex
            ]?.focus?.();
            break;
          }

          // --- Over-limit check per row ---
          if (totalGrossWeightOfRow > parseFloat(totalGrossWeightLBS)) {
            rowErrors.deliveryLineItems = {
              _error: `Exceeded limit â€” maximum allowed is <b>${totalGrossWeightLBS} lbs</b>, current total: <b>${totalGrossWeightOfRow} lbs</b>.`
            };
            errors[rowIndex] = rowErrors;
            grossWeightRefsDelivery?.current?.[rowIndex]?.[
              itemIndex
            ]?.focus?.();
            break;
          } else {
            setGrossWeightError('');
            setShowWeightError(false);
          }
        }

        if (errors[rowIndex]) break;
      }
    }

    // --- Unit quantity mismatch summary ---
    if (errors.length === 0) {
      const discrepancies = [];

      Object.keys(pickupUnits).forEach(type => {
        const pQty = pickupUnits[type] || 0;
        const dQty = deliveryUnits[type] || 0;
        if (pQty > dQty)
          discrepancies.push(`<b>${pQty - dQty} ${type}</b> missing`);
        else if (dQty > pQty)
          discrepancies.push(`<b>${dQty - pQty} ${type}</b> extra`);
      });

      Object.keys(deliveryUnits).forEach(type => {
        if (!pickupUnits[type] && deliveryUnits[type] > 0)
          discrepancies.push(`<b>${deliveryUnits[type]} ${type}</b> extra`);
      });

      if (discrepancies.length > 0 && TLPickupMode.includes('Multiple')) {
        const message = `Quantity mismatch found: ${discrepancies.join(
          ' and '
        )}. Please verify pickup and delivery unit types and quantities.`;
        setGrossWeightError(message);
        setShowWeightError(true);
        errors[0] = { deliveryLineItems: { _unitError: message } };
      }
    }

    return errors;
  };

  const handleClearRowValidationError = (type, rowIndex, field) => {
    setTLValidationErrors(prevErrors => {
      const newErrors = { ...prevErrors };
      const rowErrors = [...(newErrors?.[type] || [])];

      if (!rowErrors[rowIndex]) return prevErrors;

      delete rowErrors[rowIndex][field];

      newErrors[type] = rowErrors;
      return newErrors;
    });
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [addAddressLoading, setAddAddressLoading] = useState(false);
  const [hideAddLocText, setHideAddLocText] = useState(false);

  function formatAddress(addressArray) {
    if (addressArray.length < 3) {
      throw new Error('Address array must have at least 3 elements.');
    }

    const city = addressArray.slice(0, -3).join(' ');
    const state = addressArray.at(-3);
    const country = addressArray.at(-1);
    const postalCode = addressArray.at(-2);

    return { city, state, country, postalCode };
  }

  const handleLoading = type => {
    alert(type);
    if (type === 'shipFrom') {
      onShipFromChange('', result);
    } else if (type === 'shipTo') {
      onShipToChange('', result);
    }
    return <div>Loading ...</div>;
  };
  const handleAddLocToDB = (result, type) => {
    setAddAddressLoading(true);
    const formatedAddress = formatAddress(result.split(' '));

    AddLocation(formatedAddress)
      .then(res => {
        res.status === 200 &&
          //   successToast(`Location "${result}", added in Database successfully!`);
          // setAddAddressLoading(false);
          // setHideAddLocText(true);
          setResult([]);
        // if (type === 'shipFrom') {
        //   setShipFromOpen(false);
        //   onShipFromChange('', result);
        //   selectShipTo.current.focus();
        // } else if (type === 'shipTo') {
        //   onShipToChange('', result);
        //   enterWeight.current.focus();
        // }
      })
      .catch(err => {
        console.log(err, 'addLocation Error');
        // ErrorToast('Server Side Error');
        // setAddAddressLoading(false);
        // setHideAddLocText(false);
      });
  };
  // Update screen width on resize
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleRemoveDrop = dropIndexToRemove => {
    setMultiDropsRows(prev =>
      prev.filter((_, index) => index !== dropIndexToRemove)
    );

    // Also optionally remove errors for that drop
    setMultiDropsErrors(prevErrors =>
      prevErrors.filter((_, index) => index !== dropIndexToRemove)
    );
  };

  const handleRemovePickup = dropPickupIndex => {
    setMultiPickupRows(prev =>
      prev.filter((_, index) => index !== dropPickupIndex)
    );
  };

  const handleAddMorePickups = () => {
    setMultiPickupRows(prev => [
      ...prev,
      {
        pickupAddress: '',
        itemText: '',
        pickupDate: shipmentDate,
        expPickDeliveryDate: '',
        pickupOpenHours: originOpenTimeValue,
        pickupCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        pickupLineItems: [
          {
            Class: '50',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue: newAddedDimensionsRow[0]?.UnitTypeValue ?? '',
            nmfc: '',
            NmbOfUnits: '1',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      }
    ]);
  };

  const handleAddMoreDrops = () => {
    setMultiDropsRows(prev => {
      const cleanedRows = prev.map(row => ({
        ...row,
        deliveryLineItems: row.deliveryLineItems.map(item => ({
          ...item,
          NmbOfUnitsError: ''
        }))
      }));

      const newRow = {
        dropAddress: '',
        expDropDeliveryDate: multiPickupRows[0]?.expPickDeliveryDate,
        expDeliveryDisplayDate: deliveryDate,
        deliveryOpenHours: originOpenTimeValue,
        deliveryCloseHours: originCloseTimeValue,
        isHazmat: false,
        company: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        deliveryLineItems: [
          {
            Class: '50',
            NmbOfUnitsError: '',
            WeightLBS: '',
            GrossWeight: '',
            UnitTypeValue:
              multiPickupRows[0]?.pickupLineItems[0]?.UnitTypeValue ?? '',
            nmfc: '',
            NmbOfUnits: '0',
            Pieces: '1',
            StackAble: false,
            Length: 0,
            Width: 0,
            Height: 0
          }
        ]
      };

      return [...cleanedRows, newRow];
    });
  };

  const handleAddMultiDropsLineItems = (e, index) => {
    setRatesDisable(false);
    setMultiDropsErrors([]);
    setMultiDropsRows(prev => {
      const updated = [...prev];

      if (!updated[index]) return prev;

      const newItem = {
        Class: '50',
        WeightLBS: '',
        GrossWeight: '',
        UnitTypeValue:
          multiPickupRows[0]?.pickupLineItems[0]?.UnitTypeValue ?? '',
        nmfc: '',
        NmbOfUnits: '0',
        Pieces: '1',
        StackAble: false,
        Length: 0,
        Width: 0,
        Height: 0,
        NmbOfUnitsError: ''
      };

      const updateddeliveryLineItems = [
        ...(updated[index].deliveryLineItems || []),
        newItem
      ].map(item => ({
        ...item,
        NmbOfUnitsError: ''
      }));

      updated[index] = {
        ...updated[index],
        deliveryLineItems: updateddeliveryLineItems
      };

      return updated;
    });
  };

  const handleRemoveMultiDropsLineItems = (dropIndex, lineIndex) => {
    setRatesDisable(false);
    setMultiDropsErrors([]);
    setMultiDropsRows(prev => {
      const updated = [...prev];

      if (!updated[dropIndex] || !updated[dropIndex].deliveryLineItems)
        return prev;

      const updateddeliveryLineItems = updated[dropIndex].deliveryLineItems
        .filter((_, idx) => idx !== lineIndex)
        .map(item => ({
          ...item,
          NmbOfUnitsError: ''
        }));

      updated[dropIndex] = {
        ...updated[dropIndex],
        deliveryLineItems: updateddeliveryLineItems
      };

      return updated;
    });
  };

  const validateUnitTypeQuantity = (
    items,
    currentLineIndex,
    newValue,
    newUnitType
  ) => {
    const currentUnits = Number(newValue || 0);

    const totalUnitsForNewType = multiPickupRows
      .flatMap(row => row.pickupLineItems)
      .filter(item => item.UnitTypeValue === newUnitType)
      .reduce((acc, item) => acc + Number(item.NmbOfUnits || 0), 0);

    const unitsInDropSameTypeExclCurrent = items.reduce((sum, item, idx) => {
      if (idx === currentLineIndex) return sum;
      return item.UnitTypeValue === newUnitType
        ? sum + Number(item.NmbOfUnits || 0)
        : sum;
    }, 0);
    setTotalNmbofUnits(totalUnitsForNewType);
    const totalTryingToAllocate = unitsInDropSameTypeExclCurrent + currentUnits;

    return {
      isValid: totalTryingToAllocate <= totalUnitsForNewType,
      totalUnitsForNewType,
      totalTryingToAllocate,
      remainingUnits: totalUnitsForNewType <= totalTryingToAllocate
    };
  };
  function calculateGrossWeightByUnitType(pickups, unitType) {
    let total = 0;

    pickups.forEach(pickup => {
      pickup.pickupLineItems.forEach(item => {
        if (item.UnitTypeValue === unitType) {
          total += Number(item.GrossWeight) || 0;
        }
      });
    });

    return total;
  }
  const handleMultilineItemChange = (dropIndex, lineIndex, field, value) => {
    const numericFields = ['GrossWeight', 'Length', 'Width', 'Height'];
    const cleanedValue = numericFields.includes(field)
      ? String(value).replace(/,/g, '')
      : value;
    const numericValue = numericFields.includes(field)
      ? Number(cleanedValue)
      : value;
    // const allowedWeight = Number(totalDimensionsWeightSum);
    const currentUnitType =
      multiDropsRows[dropIndex].deliveryLineItems[lineIndex].UnitTypeValue;
    calculateGrossWeightByUnitType(multiPickupRows, currentUnitType);
    const allowedWeight = calculateGrossWeightByUnitType(
      multiPickupRows,
      currentUnitType
    );

    if (numericFields.includes(field) && !/^\d*\.?\d*$/.test(cleanedValue)) {
      return;
    }

    let validValue = value;
    let errorMsg = '';

    setMultiDropsRows(prev => {
      const updated = [...prev];

      if (
        !updated[dropIndex] ||
        !updated[dropIndex].deliveryLineItems?.[lineIndex]
      ) {
        return prev;
      }

      let updateddeliveryLineItems = [...updated[dropIndex].deliveryLineItems];
      const currentItem = updateddeliveryLineItems[lineIndex];
      const currentItemWeight = Number(
        (currentItem.GrossWeight || '').toString().replace(/,/g, '')
      );

      // Calculate new total weight
      const currentTotalExcludingThis = prev.reduce((acc, drop, dIdx) => {
        return (
          acc +
          drop.deliveryLineItems.reduce((sub, item, lIdx) => {
            if (dIdx === dropIndex && lIdx === lineIndex) return sub;

            // âœ… Only include items with matching unit type
            if (item.UnitTypeValue !== currentUnitType) return sub;

            const w = Number(
              (item.GrossWeight || '').toString().replace(/,/g, '')
            );

            return sub + (isNaN(w) ? 0 : w);
          }, 0)
        );
      }, 0);
      const newTotalWeightIfAccepted =
        currentTotalExcludingThis + (isNaN(numericValue) ? 0 : numericValue);

      // Weight check
      if (field === 'GrossWeight') {
        setRatesDisable(false);
        if (!isNaN(numericValue) && newTotalWeightIfAccepted > allowedWeight) {
          errorMsg = `Exceeded limit. Max ${allowedWeight} lbs allowed.`;
          validValue = cleanedValue;
          setRatesDisable(true);
        }
        if (!isNaN(numericValue) && newTotalWeightIfAccepted < allowedWeight) {
          setRatesDisable(true);
          errorMsg = `Remaining gross weight ${
            allowedWeight - newTotalWeightIfAccepted
          } lbs for ${currentUnitType}`;
          validValue = cleanedValue;
        }
        // else {
        //   setRatesDisable(false);
        // }
      }
      if (field === 'StackAble') {
        updateddeliveryLineItems[lineIndex] = {
          ...updateddeliveryLineItems[lineIndex],
          [field]: value == 'Yes' ? true : false
        };
      }
      // Update the field

      if (field !== 'StackAble') {
        updateddeliveryLineItems[lineIndex] = {
          ...updateddeliveryLineItems[lineIndex],
          [field]: validValue
        };
      }

      // Get latest values after field change
      const updatedItem = updateddeliveryLineItems[lineIndex];
      const latestUnits = updatedItem.NmbOfUnits;
      const latestUnitType = updatedItem.UnitTypeValue;

      if (field === 'NmbOfUnits' && latestUnits && latestUnitType) {
        const {
          isValid,
          totalTryingToAllocate,
          totalUnitsForNewType,
          remainingUnits
        } = validateUnitTypeQuantity(
          updateddeliveryLineItems,
          lineIndex,
          latestUnits,
          latestUnitType
        );

        // âœ… New: Check same unit type across ALL drops
        const totalAcrossDropsSameUnitType = updated.reduce(
          (acc, drop, dIdx) => {
            return (
              acc +
              drop.deliveryLineItems.reduce((sub, item, lIdx) => {
                const isSameType = item.UnitTypeValue === latestUnitType;
                const isCurrent = dIdx === dropIndex && lIdx === lineIndex;
                return (
                  sub +
                  (isSameType && !isCurrent ? Number(item.NmbOfUnits || 0) : 0)
                );
              }, 0)
            );
          },
          Number(latestUnits)
        ); // include current line's units in total

        const isDropLevelValid =
          totalAcrossDropsSameUnitType <= totalUnitsForNewType;

        if (
          !remainingUnits &&
          totalUnitsForNewType - totalAcrossDropsSameUnitType !== 0
        ) {
          setRatesDisable(true);
          errorMsg = `Remaining ${
            totalUnitsForNewType - totalAcrossDropsSameUnitType
          } units to assign of "${latestUnitType}", ${totalUnitsForNewType} are allowed.`;

          // clear all first, then set only on active row
          updateddeliveryLineItems = updateddeliveryLineItems.map(
            (item, idx) => ({
              ...item,
              NmbOfUnits: idx === lineIndex ? validValue : item.NmbOfUnits,
              NmbOfUnitsError: idx === lineIndex ? errorMsg : ''
            })
          );
        } else if (
          (!isValid || !isDropLevelValid) &&
          totalUnitsForNewType - totalAcrossDropsSameUnitType !== 0
        ) {
          errorMsg = `You're trying to assign ${totalAcrossDropsSameUnitType} units of "${latestUnitType}", but only ${totalUnitsForNewType} are allowed.`;
          validValue = '';

          updateddeliveryLineItems = updateddeliveryLineItems.map(
            (item, idx) => ({
              ...item,
              NmbOfUnits: idx === lineIndex ? validValue : item.NmbOfUnits,
              NmbOfUnitsError: idx === lineIndex ? errorMsg : ''
            })
          );
        } else {
          setRatesDisable(false);

          updateddeliveryLineItems = updateddeliveryLineItems.map(
            (item, idx) => ({
              ...item,
              [field]: idx === lineIndex ? validValue : item[field],
              NmbOfUnitsError: '' // âœ… clear everywhere
            })
          );
        }
      }
      if (field === 'UnitTypeValue') {
        const hasGrossWeight = multiDropsErrors?.find(drop =>
          drop?.deliveryLineItems?.some(
            line => line.GrossWeight !== '' && line.GrossWeight != null
          )
        );
        const hasNmbOfUnits = multiDropsErrors?.find(drop =>
          drop?.deliveryLineItems?.some(
            line => line.NmbOfUnits !== '' && line.NmbOfUnits != null
          )
        );
        updateddeliveryLineItems[lineIndex] = {
          ...updateddeliveryLineItems[lineIndex],
          [field]: validValue,
          GrossWeight: hasGrossWeight
            ? ''
            : updateddeliveryLineItems[lineIndex].GrossWeight,
          NmbOfUnits: hasNmbOfUnits
            ? ''
            : updateddeliveryLineItems[lineIndex].NmbOfUnits,
          NmbOfUnitsError: hasNmbOfUnits ? '' : hasNmbOfUnits
        };

        setMultiDropsErrors([]);
      }
      updated[dropIndex] = {
        ...updated[dropIndex],
        deliveryLineItems: updateddeliveryLineItems
      };

      return updated;
    });

    // âœ… Set or clear error
    setMultiDropsErrors(prevErrors => {
      const updatedErrors = [...prevErrors];

      if (!updatedErrors[dropIndex]) {
        updatedErrors[dropIndex] = { deliveryLineItems: [] };
      }

      const dropErrors = updatedErrors[dropIndex];
      const lineErrors = dropErrors.deliveryLineItems?.[lineIndex] || {};

      const newLineErrors = {
        ...lineErrors,
        [field]: errorMsg
      };

      if (!dropErrors.deliveryLineItems) {
        dropErrors.deliveryLineItems = [];
      }

      dropErrors.deliveryLineItems[lineIndex] = newLineErrors;
      updatedErrors[dropIndex] = dropErrors;

      return updatedErrors;
    });
  };

  const handleAddLocation = () => {
    let TLquoteObj = {
      id: 0,
      defaultLocation: city,
      carrierId: 0,
      carrierName: '',
      carrierLogo: '',
      invoiceType: '',
      shipmentId: '',
      proNumber: '',
      TLPickupMode: TLPickupMode,
      temperature: temperature,
      pickupInstructions: cleanHtmlString(pickupRemarks) ?? '',
      deliveryInstructions: cleanHtmlString(deliveryRemarks) ?? '',
      unit: unit,
      orderDate: multiPickupRows[0]?.pickupDate,
      pickupDate: multiPickupRows[0]?.pickupDate,
      invoiceNumber: '',
      deliveryDate: multiDropsRows[0]?.expDropDeliveryDate,
      ExpectedDeliveryDate: multiDropsRows[0]?.expDropDeliveryDate,
      invoiceDate: multiDropsRows[0]?.expDropDeliveryDate,
      originCompany:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.companyName || ''
          : '',
      originAddress:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.streetLines || ''
          : multiPickupRows[0]?.pickupAddress || '',
      originCity:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.city || ''
          : multiPickupRows[0]?.city || '',
      originState:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.stateOrProvinceCode || ''
          : multiPickupRows[0]?.state || '',
      originZip:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.postalCode || ''
          : multiPickupRows[0]?.zip || '',
      originCountry:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.countryCode || ''
          : multiPickupRows[0]?.country || '',
      originContactPerson:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.contactName || ''
          : multiPickupRows[0]?.contactName || '',
      originContactEmail:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.contactEmail?.split(',')[0] || ''
          : multiPickupRows[0]?.email || '',
      originContactPhone:
        paymentTypeValue === 'Outbound Prepaid'
          ? selectedLocDetails[0]?.contactPhone || ''
          : multiPickupRows[0]?.phone,

      destinationCompany:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.companyName || ''
          : multiDropsRows[multiDropsRows.length - 1]?.company || '',
      destinationAddress:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.streetLines || ''
          : multiDropsRows[0]?.address || '',
      destinationCity:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.city || ''
          : multiDropsRows[0]?.city || '',
      destinationState:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.stateOrProvinceCode || ''
          : multiDropsRows[0]?.state || '',
      destinationZip:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.postalCode || ''
          : multiDropsRows[0]?.zip || '',
      destinationCountry:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.countryCode || ''
          : multiDropsRows[0]?.country || '',
      destinationContactPerson:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.contactName || ''
          : '',
      destinationContactEmail:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.contactEmail?.split(',')[0] || ''
          : '',
      destinationContactPhone:
        paymentTypeValue === 'Inbound Collect'
          ? selectedLocDetails[0]?.contactPhone || ''
          : '',
      billToCompany: '',
      billToAddress: '',
      billToCity: '',
      billToState: '',
      billToZip: '',
      billToCountry: '',
      shipmentType: 'TL',
      equipmentType: TLequipmentType,
      soNumber: '',
      clientPONumber: '',
      isHazmat: hazmatSwitch,
      pickupLineItems: [],
      deliveryLineItems: [],
      pickupNumber: '',
      shipmentStatus: 'Saved',
      cargoValue: '',
      freightTerms: paymentTypeValue.replace(/\s+/g, ''),
      paymentTerms: paymentTypeValue,
      bolNumber: '',
      customerId: '',
      shippingNotes: pickupRemarks,
      billToContactPerson: '',
      billToContactEmail: '',
      billToContactPhone: '',
      locationName: selectedLocation?.location,
      location: shipLocationValue,
      locationId: shipLocationID,
      pickupStartTime: '',
      pickupEndTime: '',
      deliverStartTime: '',
      deliverEndTime: '',
      quoteId: 0,
      shipmentCharges: 0,
      actualPickupDate: '',
      actualDeliveryDate: '',
      sessionId: '',
      quoteNumber: '',
      dispatchInput1: '',
      lastUpdatedOn: '',
      serviceType: TLDriverType,
      totalNetWeight: totalNetWeightLBS ? totalNetWeightLBS : 0,
      totalGrossWeight: totalGrossWeightLBS ? totalGrossWeightLBS : 0,
      originTerminalAddress: '',
      originTerminalCity: '',
      originTerminalState: '',
      originTerminalPostalCode: '',
      originTerminalCountry: '',
      originTerminalContact: '',
      originTerminalContantEmail: '',
      originTerminalContactPhone: '',
      destinationTerminalAddress: '',
      destinationTerminalCity: '',
      destinationTerminalState: '',
      destinationTerminalPostalCode: '',
      destinationTerminalCountry: '',
      destinationTerminalContact: '',
      destinationTerminalContantEmail: '',
      destinationTerminalContactPhone: '',
      pickupOptions: {
        inside: false,
        liftGateServices: false,
        residential: false,
        secureAccess: false,
        limitedAccess: false,
        freezeProtection: false,
        overLength: false,
        callBeforeDelivery: false,
        overLengthValue: 0
      },
      deliveryOptions: {
        inside: false,
        liftGateServices: false,
        residential: false,
        secureAccess: false,
        limitedAccess: false
      },
      pickupOptionsAccessorial: '',
      deliveryOptionAccessorial: '',
      carrierBillToCompany: '',
      carrierBillToAddress: '',
      carrierBillToCity: '',
      carrierBillToState: '',
      carrierBillToZip: '',
      carrierBillToCountry: '',
      carrierBillToContactPerson: '',
      carrierBillToContactEmail: '',
      carrierBillToContactPhone: '',
      surcharges: '',
      surchargesList: '',
      estimatedTransitDays: 0,
      shipmentMiles: calDistanceValue,
      OriginData: '',
      destinationData: '',
      salesOrderNumber: '',
      purchaseOrderNumber: '',
      freightInvoiceNumber: ''
    };
    let ApiCityFrom = originDetails?.city || '';
    let ApiStateFrom = originDetails?.state || '';
    let ApiZipFrom = originDetails?.zip || '';
    let ApiZipFromCountryCode = originDetails?.country || '';

    let ApiCityTo = destinationDetails?.city || '';
    let ApiStateTo = destinationDetails?.state || '';
    let ApiZipTo = destinationDetails?.zip || '';
    let ApiZipToCountryCode = destinationDetails?.country || '';

    let obj = {
      shipmentType: shipTypeValue,
      locationFull: selectedLocation.location,
      location: shipLocationValue,
      paymentType:
        paymentTypeValue === 'Outbound Prepaid'
          ? '0'
          : paymentTypeValue === 'Inbound Collect'
            ? '1'
            : '2',
      shipFrom: {
        city: ApiCityFrom,
        stateOrProvinceCode: ApiStateFrom,
        postalCode: ApiZipFrom,
        countryCode: ApiZipFromCountryCode,
        residential: true,
        streetLines:
          paymentTypeValue === 'Outbound Prepaid'
            ? selectedLocDetails[0]?.streetLines
            : ''
      },
      shipTo: {
        city: ApiCityTo,
        stateOrProvinceCode: ApiStateTo,
        postalCode: ApiZipTo,
        countryCode: ApiZipToCountryCode,
        residential: true,
        streetLines:
          paymentTypeValue === 'Inbound Collect'
            ? selectedLocDetails[0]?.streetLines
            : ''
      },
      shipmentDate: new Date(),
      isHazmat: hazmatSwitch,
      commodityInfo: handlePushAddedCommodityInfo(),

      pickupOptions: {
        inside: pickUpChecked ? insidePickupSwitch : false,
        liftGateServices: pickUpChecked ? liftgatePickupSwitch : false,
        residential: pickUpChecked ? residentialPickupSwitch : false,
        secureAccess: pickUpChecked ? secureAccesPickupSwitch : false,
        limitedAccess: pickUpChecked ? limitedPickupAccessSwitch : false,
        freezeProtection: pickUpChecked ? freezeProtectionPickupSwitch : false,
        overLength: pickUpChecked ? overlengthPickupSwitch : false,
        overLengthValue:
          pickUpChecked && overLengthValue ? parseFloat(overLengthValue) : 0,
        callBeforeDelivery: false
      },
      deliveryOptions: {
        inside: deliveryChecked ? insideDeliverySwitch : false,
        liftGateServices: deliveryChecked ? liftgateDeliverySwitch : false,
        residential: deliveryChecked ? residentialDeliverySwitch : false,
        secureAccess: deliveryChecked ? secureAccesDeliverySwitch : false,
        limitedAccess: deliveryChecked ? limitedDeliverySwitch : false,
        freezeProtection: false,
        overLength: false,
        overLengthValue: 0,
        callBeforeDelivery: deliveryChecked
          ? callBeforeDeliveryServicesSwitch
          : false
      },
      codAmount: CODAmount ? parseInt(CODAmount) : 0,
      declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
      agencyId: AgencyID ? AgencyID : 0,
      isGuaranteed: false,
      locationId: shipLocationID,
      originContactName: originContactName,
      originContactEmail: originContactEmail,
      originContactPhone: originContactPhone,
      destinationContactName: destinationContactName,
      destinationContactEmail: destinationContactEmail,
      destinationContactPhone: destinationContactPhone
    };

    const secondObject = {
      shipmentType: 'TL',
      locationFull: selectedLocation?.location,
      location: shipLocationValue,
      paymentType:
        paymentTypeValue === 'Outbound Prepaid'
          ? '0'
          : paymentTypeValue === 'Inbound Collect'
            ? '1'
            : '2',
      shipFrom: {
        city: obj.originCity,
        stateOrProvinceCode: obj.originState,
        postalCode: obj.originZip,
        countryCode: obj.originCountry,
        residential: false,
        streetLines: obj.originAddress
      },
      shipTo: {
        city: obj.destinationCity,
        stateOrProvinceCode: obj.destinationState,
        postalCode: obj.destinationZip,
        countryCode: obj.destinationCountry,
        residential: false, // Assuming residential is false by default
        streetLines: obj.destinationAddress
      },
      shipmentDate: obj.orderDate,
      deliveryDate: obj.deliveryDate,
      totalGrossWeight: totalGrossWeight,
      isHazmat: obj.isHazmat,
      commodityInfo: {
        freightClass: '',
        packaging: '',
        units: '',
        pieces: '',
        weight: {
          units: 'lbs', // Assuming weight units are pounds
          value: ''
        },
        nmfc: '',
        dimensions: {
          length: '',
          width: '',
          height: '',
          dimensionsUom: 'inches', // Assuming dimensions are in inches
          isStackable: false
        }
      },
      pickupOptions: {
        ...obj.pickupOptions,
        callBeforeDelivery: obj.pickupOptions.callBeforeDelivery || false
      },
      deliveryOptions: {
        ...obj.deliveryOptions,
        callBeforeDelivery: obj.deliveryOptions.callBeforeDelivery || false
      },
      codAmount: CODAmount ? parseInt(CODAmount) : 0,
      declaredValue: DeclaredValue ? parseInt(DeclaredValue) : 0,
      agencyId: 198, // Assuming agency ID is 198
      isGuaranteed: false, // Default value
      locationId: obj.locationId
    };
    // open your create dialog or trigger flow here
    dispatch(setQuickQuoteRateValues(secondObject));
    dispatch(
      setQuickQuoteTLRateValues(shipTypeValue === 'TL' ? TLquoteObj : obj)
    );

    history.push({
      pathname: '/add-locations',
      state: { type: 'quickQoute', assignedLocations: userLocationsArr }
    });
  };

  const getOrdinal = n => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };
  const finalStyle = screenWidth >= 1800 ? largeScreenStyle : responsiveStyle;
  return (
    <>
      <GlobalStyles
        styles={{
          '.MuiAutocomplete-listbox .MuiAutocomplete-option': {
            whiteSpace: 'nowrap'
          }
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: '10px 0',
          bgcolor: layoutMode === 'dark' ? '#303841' : 'transparent',
          /* â”€â”€ Cascade: match CreateCarrier input & label style â”€â”€ */
          '& .MuiInputBase-root': {
            fontSize: '13px !important',
            borderRadius: '8px !important'
          },
          '& .MuiOutlinedInput-root': { borderRadius: '8px !important' },
          '& .MuiSelect-select': { fontSize: '13px !important' },
          '& label': {
            fontSize: '11.5px !important',
            fontWeight: '500 !important',
            color: 'rgba(0,0,0,0.55) !important',
            margin: '8px 0 3px !important',
            display: 'block',
            whiteSpace: 'normal !important',
            letterSpacing: 'normal !important'
          },
          '& .MuiFormControlLabel-root': {
            display: 'inline-flex !important',
            flexDirection: 'row !important',
            alignItems: 'center !important',
            justifyContent: 'flex-start !important',
            margin: '0 !important',
            gap: 0
          },
          '& .MuiGrid-item': { alignSelf: 'flex-start' }
        }}
      >
        <ToastContainer
          position='top-center'
          style={
            isMobile
              ? { width: '100%', display: 'flex', justifyContent: 'center' }
              : { width: 'auto' }
          }
          autoClose={7000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Snackbar
          sx={{ mb: 3 }}
          open={showWeightError}
          // autoHideDuration={8000}
          onClose={() => setShowWeightError(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={() => setShowWeightError(false)}
            severity='error'
            sx={{
              ml: 9,
              width: '100%',
              borderRadius: 2,
              boxShadow: 5,
              fontSize: 14
              // py: 1
            }}
          >
            <span dangerouslySetInnerHTML={{ __html: grossWeightError }} />
          </Alert>
        </Snackbar>
        <MetaTags>
          {/* <title>TMS | Quick Quote</title> */}
          <title>
            {' '}
            {base_url === 'https://beta.api.shiptechpro.com/'
              ? 'Quick Quote | Shiptechpro'
              : 'Quick Quote | TMS'}
          </title>
        </MetaTags>
        <Box
          sx={{
            width: '100%',
            maxWidth: { xs: '100%', sm: '92%', md: '88%', lg: '80%', xl: 1100 },
            mx: 'auto',
            px: { xs: 0.5, sm: 1 },
            py: 0.5
          }}
        >
          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              border: '1px solid',
              borderColor: '#E0E8F5',
              width: '100%',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E8F5' },
              '& .MuiOutlinedInput-root:hover:not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline':
                { borderColor: '#C5D8F0' },
              '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                { borderColor: '#005AFF' },
              '& input::placeholder': { color: '#58667E', opacity: 1 },
              '& textarea::placeholder': { color: '#58667E', opacity: 1 }
            }}
          >
            <Box
              sx={{
                p: { xs: 0.75, sm: 1 },
                position: 'relative'
              }}
            >
              <QSectionHeader
                icon={ArticleOutlinedIcon}
                title='Shipment Information'
                iconBg='#EBF2FF'
                iconColor='#005AFF'
              />
              <Grid container spacing={1.5}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={shipTypeValue === 'TL' ? 2 : 3}
                  lg={shipTypeValue === 'TL' ? 2 : 3}
                  xl={shipTypeValue === 'TL' ? 2 : 3}
                >
                  <QFieldLabel label='Ship Type' required />
                  <Autocomplete
                    sx={{ m: 0, p: 0 }}
                    // multiple
                    fullWidth
                    size='small'
                    openOnFocus
                    // renderOption={(props, option) => (
                    //   <Box style={{ fontSize: 12, m: 0, p: 0 }} {...props}>
                    //     {option}
                    //   </Box>
                    // )}
                    options={ShipTypeArr}
                    value={selectedOptions}
                    onChange={(event, newValue) => {
                      setValidationErrors({
                        ...validationErrors,
                        shipTypeErr: null
                      });
                      if (newValue === 'TL') {
                        setSelectedOptions(newValue);
                        setShipTypeValue(newValue);
                        handleTlFlow();
                      } else if (newValue === 'LTL') {
                        setSelectedOptions(newValue);
                        setShipTypeValue(newValue);
                        handleLTLFlow();
                      } else if (newValue === 'Parcel') {
                        setSelectedOptions(newValue);
                        setShipTypeValue(newValue);
                        handleParcelFlow();
                      } else if (newValue === 'LTL/Parcel') {
                        setSelectedOptions(newValue);
                        setShipTypeValue(newValue);
                        handleLTLFlow();
                      }
                    }}
                    // isOptionDisabled={option => isOptionDisabled(option)}
                    renderOption={(props, option) => {
                      // const disabled = isOptionDisabled(option);
                      return (
                        <li
                          {...props}
                          style={{
                            fontSize: 13
                            // opacity: disabled ? 0.5 : 1,
                            // pointerEvents: disabled ? 'none' : 'auto'
                          }}
                        >
                          {option}
                        </li>
                      );
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        error={Boolean(validationErrors['shipTypeErr'])}
                        helperText={validationErrors['shipTypeErr']}
                        placeholder='Select ship type'
                        variant='standard'
                        sx={{
                          '& .MuiChip-root': {
                            fontSize: '13px',
                            height: '18px'
                          }
                        }}
                        InputProps={{ ...params.InputProps }}
                        inputRef={selectShipType}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={shipTypeValue === 'TL' ? 3 : 5}
                  lg={shipTypeValue === 'TL' ? (isReefer ? 2 : 3) : 5}
                  xl={shipTypeValue === 'TL' ? (isReefer ? 2 : 3) : 5}
                >
                  <QFieldLabel label='Ship Location' required />
                  <Autocomplete
                    fullWidth
                    disableClearable
                    openOnFocus
                    size='small'
                    // âœ… Selected option object
                    value={selectedLocation || null}
                    // âœ… Text inside the input
                    inputValue={shipLocationValue || ''}
                    // Needed when your options are objects
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id
                    }
                    // Keep your hover logic
                    onHighlightChange={(event, option) => {
                      !locationInputChange && setLocationHoveredValue(option);
                    }}
                    options={[
                      ...shipLocation,
                      ...(addLocPermission || UserIsAdmin
                        ? [
                            {
                              isButton: true,
                              label: '+ Add Location',
                              id: 'Add-location'
                            }
                          ]
                        : [])
                    ]}
                    getOptionLabel={option => {
                      if (typeof option === 'string') return option; // free typing
                      if (option?.isButton && (addLocPermission || UserIsAdmin))
                        return option.label; // special row
                      return option?.location?.split(': ')[1] || ''; // normal option
                    }}
                    filterOptions={(options, state) => {
                      const filtered = options
                        .slice(0, -1) // exclude the last "create" item from filtering
                        .filter(option =>
                          option?.location
                            ?.split(': ')[1]
                            ?.toLowerCase()
                            ?.includes(state.inputValue.toLowerCase())
                        );
                      // Always append "create" at end
                      return [...filtered, options[options.length - 1]];
                    }}
                    renderOption={(props, option, state) => {
                      if (
                        (addLocPermission || UserIsAdmin) &&
                        option.isButton
                      ) {
                        return (
                          <Box
                            {...props}
                            key='create-location'
                            sx={{
                              fontSize: 13,
                              fontWeight: 600,
                              color: 'primary.main',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            {option.label}
                          </Box>
                        );
                      }
                      return (
                        <Box {...props} key={state.index} sx={{ fontSize: 13 }}>
                          <b>{option?.location.split(': ')[0] + ': '}</b>
                          &nbsp;
                          {option?.location.split(': ')[1]}
                        </Box>
                      );
                    }}
                    // âœ… Select option
                    onChange={(event, newValue, reason) => {
                      handleShipLocationChange(event, newValue, reason);
                    }}
                    // âœ… Typing in the field
                    onInputChange={(event, newInputValue, reason) => {
                      handleShipLocationChange(event, newInputValue, reason);
                    }}
                    loading={shipLocationLoader}
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant='standard'
                        placeholder='Select location'
                        error={Boolean(validationErrors['shipTypeLocation'])}
                        helperText={validationErrors['shipTypeLocation']}
                        onKeyDown={e => {
                          if (e.key === 'Tab' && locationHoveredValue) {
                            handleShipLocationChange(
                              e,
                              locationHoveredValue,
                              'selectOption'
                            );
                            setOpenShipFrom(false);
                            setOpenShipTo(false);
                          }
                        }}
                        inputRef={selectLocations}
                        InputProps={{ ...params.InputProps }}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={shipTypeValue === 'TL' ? 2 : 3}
                  lg={shipTypeValue === 'TL' ? 2 : 3}
                  xl={shipTypeValue === 'TL' ? 2 : 3}
                >
                  <QFieldLabel label='Payment Type' required />
                  <Autocomplete
                    fullWidth
                    disableClearable
                    // onHighlightChange={(event, option) => {
                    //   !paymentTypeInputChange &&
                    //     setPaymentTypeHoveredValue(option);
                    // }}
                    onBlur={() => {
                      setPaymentTypeInputChange(false);
                      if (paymentTypeHoveredValue) {
                        handleChangePaymentType(null, paymentTypeHoveredValue);
                      }
                    }}
                    openOnFocus
                    renderOption={(props, option) => (
                      <Box style={{ fontSize: 13 }} {...props}>
                        {option}
                      </Box>
                    )}
                    size='small'
                    options={
                      // shipTypeValue === 'LTL'
                      //   ?
                      LTLPaymentTypeArr
                      // : parcelPaymentTypeArr
                    }
                    disabled={!shipLocationValue ? true : false}
                    value={
                      // SelectedRates?.paymentType
                      //   ? SelectedRates?.paymentType
                      // :
                      paymentTypeValue
                    }
                    onChange={(event, newValue) => {
                      setPaymentTypeInputChange(false);
                      handleChangePaymentType(event, newValue);
                    }}
                    onInputChange={(event, newValue) =>
                      handleChangePaymentType(event, newValue)
                    }
                    // sx={{ marginLeft: 1 }}
                    renderInput={params => (
                      <TextField
                        onKeyDown={e => {
                          if (e.key === 'Tab' && paymentTypeHoveredValue) {
                            handleChangePaymentType(e, paymentTypeHoveredValue);
                            setOpenShipFrom(false);
                            setOpenShipTo(false);
                          }
                        }}
                        error={Boolean(validationErrors['paymentTypeErr'])}
                        helperText={validationErrors['paymentTypeErr']}
                        // sx={{ width: 290 }}
                        placeholder='Select payment type'
                        variant='standard'
                        {...params}
                        InputProps={{ ...params.InputProps }}
                      />
                    )}
                  />
                </Grid>
                {shipTypeValue === 'TL' && (
                  <>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={isReefer ? 1.5 : 2.5}
                      lg={isReefer ? 1.5 : 2.5}
                      xl={isReefer ? 1.5 : 2.5}
                    >
                      <QFieldLabel label='Equipment Type' required />
                      <FormControl fullWidth size='small' variant='standard'>
                        <Select
                          size='small'
                          value={TLequipmentType}
                          onChange={handleTLequipmentTypeChnage}
                          sx={{
                            fontSize: 13,
                            '& .MuiSelect-select': { fontSize: 13 }
                          }}
                        >
                          {TLequipmentArr.map(items => (
                            <MenuItem
                              key={items}
                              value={items}
                              sx={{ fontSize: 13 }}
                            >
                              {items}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {isReefer && (
                      <Grid item xs={12} sm={6} md={2} lg={2} xl={2}>
                        <QFieldLabel label='Required Temperature' required />
                        <Box display='flex' gap={0}>
                          <TextField
                            error={Boolean(tempError)}
                            helperText={tempError}
                            fullWidth
                            type='number'
                            placeholder={
                              unit === '°C' ? 'e.g., -5.5°C' : 'e.g., 23°F'
                            }
                            value={temperature}
                            onChange={e => {
                              setTempError('');
                              setTemperature(e.target.value);
                            }}
                            inputProps={{
                              step: '0.1',
                              min: unit === '°C' ? -30 : -22,
                              max: unit === '°C' ? 30 : 86,
                              style: { padding: '8px 10px', fontSize: 13 }
                            }}
                            InputProps={{ sx: { height: 36 } }}
                            size='small'
                            variant='standard'
                            sx={{
                              '& .MuiInputBase-root': {
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                height: 36,
                                fontSize: 13
                              }
                            }}
                          />
                          <TextField
                            select
                            value={unit}
                            onChange={e => setUnit(e.target.value)}
                            size='small'
                            variant='standard'
                            sx={{
                              minWidth: '4.5rem',
                              '& .MuiInputBase-root': {
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                                height: 36,
                                fontSize: 13,
                                paddingRight: '6px'
                              },
                              '& .MuiSelect-select': { padding: '8px 10px' }
                            }}
                          >
                            <MenuItem value='°C' sx={{ fontSize: 13 }}>
                              °C
                            </MenuItem>
                            <MenuItem value='°F' sx={{ fontSize: 13 }}>
                              °F
                            </MenuItem>
                          </TextField>
                        </Box>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6} md={1.5} lg={1.5} xl={1.5}>
                      <QFieldLabel label='Driver Type' required />
                      <FormControl fullWidth size='small' variant='standard'>
                        <Select
                          size='small'
                          value={TLDriverType}
                          onChange={handleTLDriverTypeChange}
                          sx={{
                            fontSize: 13,
                            '& .MuiSelect-select': { fontSize: 13 }
                          }}
                        >
                          <MenuItem value={'Team'} sx={{ fontSize: 13 }}>
                            Team
                          </MenuItem>
                          <MenuItem value={'Solo'} sx={{ fontSize: 13 }}>
                            Solo
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )}
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={1}
                  lg={1}
                  xl={1}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end'
                  }}
                >
                  <QFieldLabel label='Hazmat' />
                  <HazmatToggle
                    checked={hazmatSwitch}
                    onChange={() => setHazmatSwitch(c => !c)}
                  />
                </Grid>
              </Grid>
              <>
                <Divider sx={{ my: 1 }} />
                <Grid container spacing={1.5}>
                  {/* Pickup Information Card */}
                  <Grid item xs={12} sm={6}>
                    <Paper
                      variant='outlined'
                      sx={{ p: 1.5, borderRadius: 2, height: '100%' }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 0.75
                        }}
                      >
                        <Box
                          sx={{
                            bgcolor: '#EBF2FF',
                            borderRadius: 1,
                            p: 0.5,
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <FmdGoodOutlinedIcon
                            sx={{ color: '#005AFF', fontSize: 18 }}
                          />
                        </Box>
                        <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                          Pickup Information
                        </Typography>
                      </Box>

                      <QFieldLabel label='Pickup Address' required />
                      <AddressAutocomplete
                        label=''
                        inputVariant='standard'
                        locationFlow={shipTypeValue === 'TL' ? 'TL' : 'LTL'}
                        inputType='quickQuote'
                        disabled={paymentTypeValue === 'Outbound Prepaid'}
                        defaultValue={
                          paymentTypeValue === 'Outbound Prepaid' &&
                          selectedLocDetails?.[0]
                            ? [
                                selectedLocDetails[0].streetLines,
                                selectedLocDetails[0].city,
                                selectedLocDetails[0].stateOrProvinceCode,
                                selectedLocDetails[0].postalCode
                              ]
                                .filter(Boolean)
                                .join(', ')
                            : originDetails
                              ? [
                                  originDetails.streetLines,
                                  originDetails.city,
                                  originDetails.state,
                                  originDetails.zip
                                ]
                                  .filter(Boolean)
                                  .join(', ')
                              : ''
                        }
                        onSelectDetails={details => setOriginDetails(details)}
                        validattionErrors={validationErrors}
                        errorMsg='shipFromErr'
                      />

                      <Grid container spacing={0.75}>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Contact Person' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            value={originContactName}
                            onChange={e => setOriginContactName(e.target.value)}
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Phone Number' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            value={originContactPhone}
                            onChange={e =>
                              setOriginContactPhone(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Email Address' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            value={originContactEmail}
                            onChange={e =>
                              setOriginContactEmail(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={0.75} sx={{ mt: 0.25 }}>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Pickup Date' required />
                          <DateRangeFilter
                            inputRef={pickupDatepickerRef}
                            handleIconClick={handlePickupDateIconClick}
                            styleProp='quickQuote'
                            selected={shipmentDate}
                            onChange={date => setShipmentDate(date.date)}
                            placeholderText={
                              paymentTypeValue === 'Outbound Prepaid'
                                ? ''
                                : 'Select Pickup Date'
                            }
                            minDate={new Date()}
                            disabled={shipTypeValue === 'LTL'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Open Time' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            type='time'
                            value={originOpenTimeValue}
                            onChange={e =>
                              setOriginOpenTimeValue(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Close Time' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            type='time'
                            value={originCloseTimeValue}
                            onChange={e =>
                              setOriginCloseTimeValue(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                      </Grid>

                      <Box sx={{ mt: 0.75 }}>
                        <QFieldLabel label='Pickup Instructions (Optional)' />
                        <TextField
                          fullWidth
                          variant='standard'
                          multiline
                          rows={2}
                          size='small'
                          value={pickupRemarks}
                          onChange={e => setPickupRemarks(e.target.value)}
                          placeholder='Enter pickup instructions...'
                          inputProps={{
                            maxLength: 500,
                            style: { fontSize: 12 }
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: 10,
                            color: 'text.secondary',
                            textAlign: 'right'
                          }}
                        >
                          {(pickupRemarks || '').length} / 500
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>

                  {/* Delivery Information Card */}
                  <Grid item xs={12} sm={6}>
                    <Paper
                      variant='outlined'
                      sx={{ p: 1.5, borderRadius: 2, height: '100%' }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 0.75
                        }}
                      >
                        <Box
                          sx={{
                            bgcolor: '#ECFDF5',
                            borderRadius: 1,
                            p: 0.5,
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          <FmdGoodOutlinedIcon
                            sx={{ color: '#10B981', fontSize: 18 }}
                          />
                        </Box>
                        <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
                          Delivery Information
                        </Typography>
                      </Box>

                      <QFieldLabel label='Delivery Address' required />
                      <AddressAutocomplete
                        label=''
                        inputVariant='standard'
                        locationFlow={shipTypeValue === 'TL' ? 'TL' : 'LTL'}
                        inputType='quickQuote'
                        disabled={paymentTypeValue === 'Inbound Collect'}
                        defaultValue={
                          paymentTypeValue === 'Inbound Collect' &&
                          selectedLocDetails?.[0]
                            ? [
                                selectedLocDetails[0].streetLines,
                                selectedLocDetails[0].city,
                                selectedLocDetails[0].stateOrProvinceCode,
                                selectedLocDetails[0].postalCode
                              ]
                                .filter(Boolean)
                                .join(', ')
                            : destinationDetails
                              ? [
                                  destinationDetails.streetLines,
                                  destinationDetails.city,
                                  destinationDetails.state,
                                  destinationDetails.zip
                                ]
                                  .filter(Boolean)
                                  .join(', ')
                              : ''
                        }
                        onSelectDetails={details =>
                          setDestinationDetails(details)
                        }
                        validattionErrors={validationErrors}
                        errorMsg='shipToErr'
                      />

                      <Grid container spacing={0.75}>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Contact Person' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            value={destinationContactName}
                            onChange={e =>
                              setDestinationContactName(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Phone Number' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            value={destinationContactPhone}
                            onChange={e =>
                              setDestinationContactPhone(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Email Address' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            value={destinationContactEmail}
                            onChange={e =>
                              setDestinationContactEmail(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={0.75} sx={{ mt: 0.25 }}>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Exp. Delivery Date' required />
                          <DateRangeFilter
                            inputRef={deliveryDatepickerRef}
                            handleIconClick={handleDeliveryDateIconClick}
                            styleProp='quickQuote'
                            selected={deliveryDate || null}
                            onChange={date => setDeliveryDate(date.date)}
                            placeholderText={
                              paymentTypeValue === 'Inbound Collect'
                                ? ''
                                : 'Select Delivery Date'
                            }
                            minDate={shipmentDate || new Date()}
                            disabled={shipTypeValue === 'LTL'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Open Time' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            type='time'
                            value={deliveryOpenTimeValue}
                            onChange={e =>
                              setDeliveryOpenTimeValue(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <QFieldLabel label='Close Time' required />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            type='time'
                            value={deliveryCloseTimeValue}
                            onChange={e =>
                              setDeliveryCloseTimeValue(e.target.value)
                            }
                            InputProps={{ style: { fontSize: 12 } }}
                          />
                        </Grid>
                      </Grid>

                      <Box sx={{ mt: 0.75 }}>
                        <QFieldLabel label='Delivery Instructions (Optional)' />
                        <TextField
                          fullWidth
                          variant='standard'
                          multiline
                          rows={2}
                          size='small'
                          value={deliveryRemarks}
                          onChange={e => setDeliveryRemarks(e.target.value)}
                          placeholder='Enter delivery instructions...'
                          inputProps={{
                            maxLength: 500,
                            style: { fontSize: 12 }
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: 10,
                            color: 'text.secondary',
                            textAlign: 'right'
                          }}
                        >
                          {(deliveryRemarks || '').length} / 500
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>

                {/* Miles indicator */}
                {distanceMiles > 0 && (
                  <Box
                    sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        border: '1px solid',
                        borderColor: 'primary.200',
                        borderRadius: '8px',
                        px: 2,
                        py: 0.5,
                        bgcolor: 'primary.50'
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 10,
                          fontWeight: 500,
                          color: 'text.secondary',
                          lineHeight: 1
                        }}
                      >
                        Miles
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: 'primary.main',
                          lineHeight: 1.3
                        }}
                      >
                        {distanceMiles}
                      </Typography>
                    </Box>
                  </Box>
                )}

                {/* Commodity Info */}
                <div>
                  <Divider sx={{ my: 1 }} />
                  <QSectionHeader
                    icon={Inventory2OutlinedIcon}
                    title='Commodity Info'
                    iconBg='#EBF2FF'
                    iconColor='#005AFF'
                  />
                </div>
              </>

              <>
                {shipTypeValue === 'Tanker' ? (
                  <div style={{ height: '20vh' }}>
                    <ReactQuill
                      style={{ height: '15vh' }}
                      // value={pickupInstContent}
                      // onChange={handlePickupInstEditorChange}
                    />
                  </div>
                ) : (
                  newAddedDimensionsRow.map((items, index, arr) => (
                    <Grid container spacing={0.5}>
                      <Grid item xs={6} sm={4} md={2} lg={2} xl={2}>
                        <QFieldLabel
                          label={
                            shipTypeValue === 'TL'
                              ? 'Net Weight (lbs)'
                              : 'Weight (lbs)'
                          }
                          required
                        />
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5
                          }}
                        >
                          {index + 1 === arr.length && arr.length > 1 ? (
                            <AddIcon
                              style={{
                                cursor: 'pointer',
                                fontSize: 20,
                                flexShrink: 0,
                                color: '#005AFF'
                              }}
                              onClick={() => handleAddNewRow('dimensions')}
                            />
                          ) : arr.length == 1 ? (
                            <AddIcon
                              style={{
                                cursor: 'pointer',
                                fontSize: 20,
                                flexShrink: 0,
                                color: '#005AFF'
                              }}
                              onClick={() => handleAddNewRow('dimensions')}
                            />
                          ) : (
                            <RemoveCircleIcon
                              style={{
                                cursor: 'pointer',
                                fontSize: 20,
                                flexShrink: 0,
                                color: '#EF4444'
                              }}
                              onClick={() =>
                                handleSubtractNewRow('dimensions', index)
                              }
                            />
                          )}
                          <TextField
                            fullWidth
                            className={classes.inputRoot}
                            inputRef={enterWeight}
                            error={Boolean(
                              validationErrors[`weightEr${index}`]
                            )}
                            helperText={validationErrors[`weightEr${index}`]}
                            FormHelperTextProps={{
                              style: { whiteSpace: 'nowrap', margin: '0 0 0 0' }
                            }}
                            value={
                              items.WeightLBS === 0
                                ? ''
                                : formatNumberWithCommas(items.WeightLBS)
                            }
                            onChange={e =>
                              handleDimensionsInputChange('WeightLBS', index, e)
                            }
                            variant='standard'
                            size='small'
                            id='outlined-weight'
                            type='text'
                            InputProps={{
                              inputMode: 'numeric',
                              style: { height: 32, fontSize: 12 }
                            }}
                          />
                        </Box>
                      </Grid>

                      {shipTypeValue !== 'Parcel' && (
                        <Grid item xs={6} sm={4} md={1.5} lg={1.5} xl={1.5}>
                          <QFieldLabel label='Freight Class' required />
                          <Autocomplete
                            fullWidth
                            // onHighlightChange={(event, option) => {
                            //   setFreightClassHoveredValue(option);
                            // }}
                            disableClearable
                            onBlur={() => {
                              if (freightClassHoveredValue) {
                                handleDimensionsInputChange(
                                  'Class',
                                  index,
                                  freightClassHoveredValue
                                );
                              }
                            }}
                            renderOption={(props, option) => (
                              <Box style={{ fontSize: 13 }} {...props}>
                                {option}
                              </Box>
                            )}
                            name='Class'
                            size='small'
                            componentsProps={{
                              popper: {
                                style: {
                                  width: 'fit-content',
                                  minWidth: '120px'
                                }
                              }
                            }}
                            options={ClassArray}
                            // defaultValue={'50'}
                            value={items.Class}
                            onChange={(event, newValue) =>
                              handleDimensionsInputChange(
                                'Class',
                                index,
                                newValue
                              )
                            }
                            onInputChange={(event, newValue) => {
                              if (newValue) {
                                const filtered = ClassArray.filter(option =>
                                  option
                                    .toLowerCase()
                                    .includes(newValue.toLowerCase())
                                );
                                setFreightClassHoveredValue(
                                  filtered[0] || null
                                );
                              } else {
                                setFreightClassHoveredValue(null);
                              }
                            }}
                            // sx={{ marginLeft: 1 }}
                            renderInput={params => (
                              <TextField
                                onKeyDown={e => {
                                  if (
                                    e.key === 'Tab' &&
                                    freightClassHoveredValue
                                  ) {
                                    // e.preventDefault(); // prevent the default Tab behavior
                                    handleDimensionsInputChange(
                                      'Class',
                                      e,
                                      freightClassHoveredValue
                                    );
                                  }
                                }}
                                // sx={{ width: 90 }}
                                // placeholder='Payment Type'
                                variant='standard'
                                {...params}
                                InputProps={{
                                  style: { fontSize: 12, height: 32 },
                                  ...params.InputProps
                                }}
                              />
                            )}
                          />
                        </Grid>
                      )}
                      <>
                        <Grid item xs={6} sm={4} md={1.5} lg={1.5} xl={1.5}>
                          <QFieldLabel label='Unit Type' required />
                          <Autocomplete
                            // onHighlightChange={(event, option) => {
                            //   setUnitTypeHoveredValue(option);
                            // }}
                            disableClearable
                            fullWidth
                            onBlur={() => {
                              if (unitTypeHoveredValue) {
                                handleDimensionsInputChange(
                                  'UnitType',
                                  index,
                                  unitTypeHoveredValue
                                );
                              }
                            }}
                            renderOption={(props, option) => (
                              <Box style={{ fontSize: 13 }} {...props}>
                                {option}
                              </Box>
                            )}
                            // sx={{ m: 1 }}
                            size='small'
                            options={
                              shipTypeValue === 'Parcel'
                                ? ParcelUnitTypeArr
                                : LTLUnitTypeArr
                            }
                            value={
                              // shipTypeValue === 'Parcel'
                              //   ? ParcelUnitTypeArr[0]
                              //   :
                              items.UnitTypeValue
                            }
                            onChange={(event, newValue) => {
                              handleDimensionsInputChange(
                                'UnitType',
                                index,
                                newValue
                              );
                            }}
                            onInputChange={(event, newValue) => {
                              handleDimensionsInputChange(
                                'UnitType',
                                index,
                                newValue
                              );
                            }}
                            // sx={{ marginLeft: 1 }}
                            renderInput={params => (
                              <TextField
                                fullWidth
                                onKeyDown={e => {
                                  if (e.key === 'Tab' && unitTypeHoveredValue) {
                                    // e.preventDefault(); // prevent the default Tab behavior
                                    handleDimensionsInputChange(
                                      'UnitType',
                                      e,
                                      unitTypeHoveredValue
                                    );
                                  }
                                }}
                                // type='number'
                                // sx={{ width: 120 }}
                                // sx={
                                //   shipTypeValue === 'LTL'
                                //     ? { width: 120 }
                                //     : { width: 190 }
                                // }
                                variant='standard'
                                {...params}
                                InputProps={{
                                  style: { fontSize: 12, height: 32 },
                                  ...params.InputProps
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={4} sm={3} md={1} lg={1} xl={1}>
                          <QFieldLabel label='Units' required />
                          <TextField
                            fullWidth
                            error={Boolean(
                              validationErrors[`numberOfUnits${index}`]
                            )}
                            helperText={
                              validationErrors[`numberOfUnits${index}`]
                            }
                            FormHelperTextProps={{
                              style: {
                                whiteSpace: 'nowrap',
                                margin: '0 0 -15 0'
                              }
                            }}
                            value={formatNumberWithCommas(items.NmbOfUnits)}
                            onChange={e =>
                              handleDimensionsInputChange(
                                'NmbOfUnits',
                                index,
                                e
                              )
                            }
                            variant='standard'
                            size='small'
                            type='text'
                            InputProps={{
                              style: { height: 32, fontSize: 12 },
                              inputProps: { min: 0 }
                            }}
                          />
                        </Grid>
                        <Grid item xs={4} sm={3} md={1} lg={1} xl={1}>
                          <QFieldLabel label='Pieces' required />
                          <TextField
                            fullWidth
                            error={Boolean(
                              validationErrors[`numberOfPieces${index}`]
                            )}
                            helperText={
                              validationErrors[`numberOfPieces${index}`]
                            }
                            FormHelperTextProps={{
                              style: {
                                whiteSpace: 'nowrap',
                                margin: '0 0 -15 0'
                              }
                            }}
                            value={formatNumberWithCommas(items.Pieces)}
                            onChange={e =>
                              handleDimensionsInputChange('Pieces', index, e)
                            }
                            variant='standard'
                            size='small'
                            type='text'
                            InputProps={{
                              style: { height: 32, fontSize: 12 },
                              inputProps: { min: 0 }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'flex-end',
                              justifyContent: 'space-between'
                              // mb: 0.25
                            }}
                          >
                            <QFieldLabel
                              label='Dims (in): L — W — H'
                              required
                            />
                          </Box>

                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5
                            }}
                          >
                            <Box sx={{ display: 'flex', gap: 0.5, flex: 1 }}>
                              <TextField
                                fullWidth
                                error={Boolean(
                                  validationErrors['PlengthError']
                                )}
                                helperText={validationErrors['PlengthError']}
                                FormHelperTextProps={{
                                  style: {
                                    whiteSpace: 'nowrap',
                                    margin: '0 0 -10 0'
                                  }
                                }}
                                value={
                                  items.Length
                                    ? formatNumberWithCommas(items.Length)
                                    : ''
                                }
                                onChange={e =>
                                  handleDimensionsInputChange(
                                    'Length',
                                    index,
                                    e
                                  )
                                }
                                type='text'
                                onKeyPress={handleKeyPress}
                                variant='standard'
                                size='small'
                                className={classes.input}
                                InputProps={{
                                  style: {
                                    height: 32,
                                    fontSize: 12,
                                    textAlign: 'center'
                                  }
                                }}
                              />
                              <TextField
                                fullWidth
                                variant='standard'
                                error={Boolean(validationErrors['PwidthError'])}
                                helperText={validationErrors['PwidthError']}
                                FormHelperTextProps={{
                                  style: {
                                    whiteSpace: 'nowrap',
                                    margin: '0 0 -10 0'
                                  }
                                }}
                                value={
                                  items.Width
                                    ? formatNumberWithCommas(items.Width)
                                    : ''
                                }
                                onChange={e =>
                                  handleDimensionsInputChange('Width', index, e)
                                }
                                type='text'
                                onKeyPress={handleKeyPress}
                                className={classes.input}
                                size='small'
                                InputProps={{
                                  style: {
                                    height: 32,
                                    fontSize: 12,
                                    textAlign: 'center'
                                  }
                                }}
                              />
                              <TextField
                                variant='standard'
                                fullWidth
                                error={Boolean(
                                  validationErrors['PheightError']
                                )}
                                helperText={validationErrors['PheightError']}
                                FormHelperTextProps={{
                                  style: {
                                    whiteSpace: 'nowrap',
                                    margin: '0 0 -10 0'
                                  }
                                }}
                                value={
                                  items.Height
                                    ? formatNumberWithCommas(items.Height)
                                    : ''
                                }
                                onChange={e =>
                                  handleDimensionsInputChange(
                                    'Height',
                                    index,
                                    e
                                  )
                                }
                                type='text'
                                onKeyPress={handleKeyPress}
                                className={classes.input}
                                size='small'
                                InputProps={{
                                  style: {
                                    height: 32,
                                    fontSize: 12,
                                    textAlign: 'center'
                                  }
                                }}
                              />
                            </Box>
                          </Box>
                        </Grid>
                        {shipTypeValue !== 'Parcel' && (
                          <Grid
                            item
                            xs={4}
                            sm={2}
                            md={1}
                            lg={1}
                            xl={1}
                            sx={{ display: 'flex', flexDirection: 'column' }}
                          >
                            <QFieldLabel label='Stackable' />
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                pt: 0.25
                              }}
                            >
                              <Switch
                                size='small'
                                checked={items.StackAble}
                                value={items.StackAble}
                                onChange={(e, c) =>
                                  handleDimensionsInputChange(
                                    'Stackable',
                                    index,
                                    c
                                  )
                                }
                                sx={{
                                  '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: '#005AFF'
                                  },
                                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
                                    { backgroundColor: '#005AFF' }
                                }}
                                name='Stackable'
                              />
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  color: items.StackAble
                                    ? '#005AFF'
                                    : 'text.secondary',
                                  fontWeight: 500
                                }}
                              >
                                {items.StackAble ? 'Yes' : 'No'}
                              </Typography>
                            </Box>
                            {index + 1 === arr.length &&
                              totalDimensionsWeightSum > 0 && (
                                <Typography
                                  sx={{
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: '#005AFF',
                                    whiteSpace: 'nowrap',
                                    mt: 0.5
                                  }}
                                >
                                  Total:{' '}
                                  {formatNumberWithCommas(
                                    totalDimensionsWeightSum
                                  )}{' '}
                                  lbs
                                </Typography>
                              )}
                          </Grid>
                        )}
                        {shipTypeValue !== 'Parcel' && (
                          <Grid
                            item
                            xs={12}
                            sx={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {items.TotalVolume && (
                              <Grid
                                container
                                spacing={0.5}
                                sx={{
                                  minWidth: '50%',
                                  mt: 0.5,
                                  p: 0.5,
                                  borderRadius: 1
                                }}
                              >
                                {items.TotalVolume && (
                                  <Grid item xs={4}>
                                    <Box
                                      sx={{
                                        backgroundColor: '#e3f2fd',
                                        px: 1,
                                        py: 0.5,
                                        borderRadius: 1,
                                        textAlign: 'center'
                                      }}
                                    >
                                      <Typography
                                        variant='caption'
                                        sx={{
                                          fontSize: '11px',
                                          color: '#1976d2'
                                        }}
                                      >
                                        <strong>Total Volume:</strong>{' '}
                                        {items.TotalVolume} ftÂ³
                                      </Typography>
                                    </Box>
                                  </Grid>
                                )}

                                {items.density && (
                                  <Grid item xs={4}>
                                    <Box
                                      sx={{
                                        backgroundColor: '#fff3e0',
                                        px: 1,
                                        py: 0.5,
                                        borderRadius: 1,
                                        textAlign: 'center'
                                      }}
                                    >
                                      <Typography
                                        variant='caption'
                                        sx={{
                                          fontSize: '11px',
                                          color: '#f57c00'
                                        }}
                                      >
                                        <strong>Density:</strong>{' '}
                                        {items.density} lbs/ftÂ³
                                      </Typography>
                                    </Box>
                                  </Grid>
                                )}

                                {items.estimatedFreightClass && (
                                  <Grid item xs={4}>
                                    <Box
                                      sx={{
                                        backgroundColor: '#e8f5e9',
                                        px: 1,
                                        py: 0.5,
                                        borderRadius: 1,
                                        textAlign: 'center'
                                      }}
                                    >
                                      <Typography
                                        variant='caption'
                                        sx={{
                                          fontSize: '11px',
                                          color: '#2e7d32'
                                        }}
                                      >
                                        <strong>
                                          Estimated Freight Class :
                                        </strong>{' '}
                                        {items.estimatedFreightClass}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                )}
                              </Grid>
                            )}
                          </Grid>
                        )}
                      </>
                    </Grid>
                  ))
                )}
              </>
            </Box>
            {shipTypeValue !== 'TL' && shipTypeValue && (
              <>
                <Box sx={{ px: { xs: 1, sm: 1.5 }, pb: 1.5 }}>
                  <Divider sx={{ mb: 1.5 }} />
                  {/* Advanced Options toggle */}
                  <Box
                    onClick={() => setServicesOpen(o => !o)}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      py: 0.75,
                      cursor: 'pointer',
                      width: 'fit-content',
                      '&:hover': { opacity: 0.7 }
                    }}
                  >
                    <SettingsOutlinedIcon
                      sx={{ fontSize: 18, color: 'text.secondary' }}
                    />
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: 14,
                        color: 'text.primary'
                      }}
                    >
                      Advanced Options
                    </Typography>
                    {servicesOpen ? (
                      <ExpandLessIcon
                        sx={{ fontSize: 18, color: 'text.secondary' }}
                      />
                    ) : (
                      <ExpandMoreIcon
                        sx={{ fontSize: 18, color: 'text.secondary' }}
                      />
                    )}
                  </Box>

                  {servicesOpen && (
                    <>
                      <Grid container spacing={1.5} sx={{ mt: 1, mb: 1.5 }}>
                        {/* Left: COD + Declared Value stacked */}
                        <Grid item xs={12} sm={3}>
                          <QFieldLabel label='C.O.D Amount ($)' />
                          <TextField
                            fullWidth
                            variant='standard'
                            size='small'
                            value={CODAmount || ''}
                            placeholder='0.00'
                            onChange={e =>
                              setCODAmount(
                                e.target.value.replace(/[^0-9.]/g, '')
                              )
                            }
                            InputProps={{ style: { height: 32, fontSize: 12 } }}
                            inputProps={{ style: { fontSize: 12 } }}
                          />
                          <Box sx={{ mt: 1.5 }}>
                            <QFieldLabel label='Declared Value ($)' />
                            <TextField
                              fullWidth
                              variant='standard'
                              size='small'
                              value={DeclaredValue || ''}
                              placeholder='0.00'
                              onChange={e =>
                                setDeclaredValue(
                                  e.target.value.replace(/[^0-9.]/g, '')
                                )
                              }
                              InputProps={{
                                style: { height: 32, fontSize: 12 }
                              }}
                              inputProps={{ style: { fontSize: 12 } }}
                            />
                          </Box>
                          {overlengthPickupSwitch && (
                            <Box sx={{ mt: 1.5 }}>
                              <QFieldLabel label='Over Length Value (inches)' />
                              <TextField
                                fullWidth
                                variant='standard'
                                size='small'
                                value={overLengthValue || ''}
                                onChange={e =>
                                  setOverLengthValue(
                                    e.target.value.replace(/[^0-9.]/g, '')
                                  )
                                }
                                InputProps={{
                                  style: { height: 32, fontSize: 12 }
                                }}
                                inputProps={{ style: { fontSize: 12 } }}
                              />
                            </Box>
                          )}
                        </Grid>

                        {/* Right: Pickup & Delivery Accessories side by side */}
                        <Grid item xs={12} sm={4.5}>
                          <QFieldLabel label='Pickup Accessories' />
                          <Autocomplete
                            multiple
                            disableCloseOnSelect
                            size='small'
                            options={[
                              'Inside Pickup',
                              'Liftgate',
                              'Residential',
                              'Secure Access',
                              'Freeze Protection',
                              'Overlength',
                              'Limited Access'
                            ]}
                            value={[
                              insidePickupSwitch && 'Inside Pickup',
                              liftgatePickupSwitch && 'Liftgate',
                              residentialPickupSwitch && 'Residential',
                              secureAccesPickupSwitch && 'Secure Access',
                              freezeProtectionPickupSwitch &&
                                'Freeze Protection',
                              overlengthPickupSwitch && 'Overlength',
                              limitedPickupAccessSwitch && 'Limited Access'
                            ].filter(Boolean)}
                            onChange={(_, newVals) => {
                              setPickUpChecked(newVals.length > 0);
                              setInsidePickupSwitch(
                                newVals.includes('Inside Pickup')
                              );
                              setLiftgatePickupSwitch(
                                newVals.includes('Liftgate')
                              );
                              setResidentialPickupSwitch(
                                newVals.includes('Residential')
                              );
                              setSecureAccesPickupSwitch(
                                newVals.includes('Secure Access')
                              );
                              setFreezeProtectionPickupSwitch(
                                newVals.includes('Freeze Protection')
                              );
                              setOverlengthPickupSwitch(
                                newVals.includes('Overlength')
                              );
                              setLimitedPickupAccessSwitch(
                                newVals.includes('Limited Access')
                              );
                            }}
                            renderOption={(props, option) => (
                              <li {...props} style={{ fontSize: 12 }}>
                                {option}
                              </li>
                            )}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  key={option}
                                  label={option}
                                  size='small'
                                  {...getTagProps({ index })}
                                />
                              ))
                            }
                            renderInput={params => (
                              <TextField
                                {...params}
                                variant='standard'
                                placeholder='Select accessories...'
                                size='small'
                                InputProps={{
                                  ...params.InputProps,
                                  style: { fontSize: 12 }
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4.5}>
                          <QFieldLabel label='Delivery Accessories' />
                          <Autocomplete
                            multiple
                            disableCloseOnSelect
                            size='small'
                            options={[
                              'Inside Delivery',
                              'Liftgate',
                              'Residential',
                              'Secure Access',
                              'Call Before Delivery',
                              'Limited Access'
                            ]}
                            value={[
                              insideDeliverySwitch && 'Inside Delivery',
                              liftgateDeliverySwitch && 'Liftgate',
                              residentialDeliverySwitch && 'Residential',
                              secureAccesDeliverySwitch && 'Secure Access',
                              callBeforeDeliveryServicesSwitch &&
                                'Call Before Delivery',
                              limitedDeliverySwitch && 'Limited Access'
                            ].filter(Boolean)}
                            onChange={(_, newVals) => {
                              setDeliveryChecked(newVals.length > 0);
                              setInsideDeliverySwitch(
                                newVals.includes('Inside Delivery')
                              );
                              setLiftgateDeliverySwitch(
                                newVals.includes('Liftgate')
                              );
                              setResidentialDeliverySwitch(
                                newVals.includes('Residential')
                              );
                              setSecureAccesDeliverySwitch(
                                newVals.includes('Secure Access')
                              );
                              setCallBeforeDeliveryServicesSwitch(
                                newVals.includes('Call Before Delivery')
                              );
                              setLimitedDeliverySwitch(
                                newVals.includes('Limited Access')
                              );
                            }}
                            renderOption={(props, option) => (
                              <li {...props} style={{ fontSize: 12 }}>
                                {option}
                              </li>
                            )}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  key={option}
                                  label={option}
                                  size='small'
                                  {...getTagProps({ index })}
                                />
                              ))
                            }
                            renderInput={params => (
                              <TextField
                                {...params}
                                variant='standard'
                                placeholder='Select accessories...'
                                size='small'
                                InputProps={{
                                  ...params.InputProps,
                                  style: { fontSize: 12 }
                                }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Box>
              </>
            )}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                borderTop: '1px solid',
                borderColor: 'divider'
              }}
            >
              <Button
                variant='outlined'
                onClick={() => handleClearForm()}
                startIcon={<ArticleOutlinedIcon sx={{ fontSize: 18 }} />}
                sx={{
                  textTransform: 'none',
                  borderRadius: '8px',
                  height: 40,
                  px: 2.5,
                  fontSize: 14,
                  fontWeight: 500,
                  color: '#374151',
                  borderColor: '#D1D5DB',
                  bgcolor: '#FFFFFF',
                  '&:hover': { bgcolor: '#F9FAFB', borderColor: '#9CA3AF' }
                }}
              >
                Clear Form
              </Button>
              <Button
                variant='contained'
                disabled={ratesDisable}
                onClick={e => handleGetRates(e)}
                startIcon={<LocalShippingOutlinedIcon sx={{ fontSize: 18 }} />}
                sx={{
                  textTransform: 'none',
                  borderRadius: '8px',
                  height: 40,
                  px: 2.5,
                  fontSize: 14,
                  fontWeight: 500,
                  bgcolor: '#005AFF',
                  '&:hover': { bgcolor: '#0047CC' },
                  '&.Mui-disabled': { bgcolor: 'action.disabledBackground' }
                }}
              >
                {getRateLoading ? 'Loadingâ€¦' : 'Get Rates'}
              </Button>
            </Box>
          </Paper>
        </Box>
      </Box>
    </>
  );
}

export default QuickQuote;
